import React from "react";
import SchoolofManagementImage from "../assets/img/schoolbanner/school-of-management.webp";
import SchoolofScienceImage from "../assets/img/schoolbanner/school-of-science.webp";
import SchoolofCommerceImage from "../assets/img/schoolbanner/school-of-commerce.webp";
import SchoolofArtsandHumanitiesImage from "../assets/img/schoolbanner/school-of-arts-and-humanities.webp";
import SchoolofEngineeringandTechnologyImage from "../assets/img/schoolbanner/school-of-engineering-and-technology.webp";
import SchoolofInformationandTechnologyImage from "../assets/img/schoolbanner/school-of-information-and-technology.webp";
import SchoolofDesignImage from "../assets/img/schoolbanner/school-of-design.webp";
import SchoolofPharmacyImage from "../assets/img/schoolbanner/school-of-pharmacy.webp";
import SchoolofLifeScienceImage from "../assets/img/schoolbanner/school-of-life-science.webp";
import SchoolofYogaandNaturopathyImage from "../assets/img/schoolbanner/school-of-yoga-and-naturopathy.webp";
import SchoolofLawImage from "../assets/img/schoolbanner/school-of-law.webp";
import SchoolofLibraryandInformationScienceImage from "../assets/img/schoolbanner/school-of-library-and-information-science.webp";
import SchoolofJournalismandMassCommunicationImage from "../assets/img/schoolbanner/school-of-journalism-and-mass-communication.webp";
import SchoolofEducationImage from "../assets/img/schoolbanner/school-of-education.webp";
import SchoolofHotelManagementImage from "../assets/img/schoolbanner/school-of-hotel-management.webp";
import SchoolofHealthandAlliedScienceImage from "../assets/img/schoolBannerImages/school-of-health-and-allied-science.png";
import SchoolOfVocationalManagementImage from "../assets/img/schoolbanner/school-of-vocational-management.webp";
import SchoolofMediaandEntertainmentImage from "../assets/img/schoolbanner/school-of-media-and-entertainment.webp";

const palette = {
    navy: "#071A2F",
    navy2: "#0C2744",
    gold: "#D5AD57",
    gold2: "#A77B2D",
    ivory: "#F7F2E8",
    white: "#FFFFFF",
    ink: "#132337",
    burgundy: "#8B1E3F",
};

const sectors = ["Software & Web", "Cloud & Networks", "Digital Marketing", "Design & Media", "Events & Sports", "Manufacturing & Law"];



const Arrow = ({ diagonal = false, className = "h-4 w-4" }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className={className} aria-hidden="true">
        {diagonal ? (
            <path d="M7 17 17 7M8 7h9v9" strokeLinecap="round" strokeLinejoin="round" />
        ) : (
            <path d="M5 12h14M13 6l6 6-6 6" strokeLinecap="round" strokeLinejoin="round" />
        )}
    </svg>
);


const engineeringDomains = ["AI & ML", "Robotics", "Civil Systems", "Mechanical Design", "Smart Energy", "Industry 4.0"];
const engineeringHighlights = [
    { value: "29+", label: "Engineering pathways" },
    { value: "Future", label: "Technology specialisations" },
    { value: "Applied", label: "Laboratory learning" },
    { value: "Industry", label: "Career preparation" },
];
const networkNodes = [["8%", "18%"], ["21%", "68%"], ["39%", "28%"], ["52%", "78%"], ["68%", "17%"], ["82%", "62%"], ["93%", "30%"]];
const focusAreas = [
    { number: "01", title: "Artificial Intelligence", icon: "AI" },
    { number: "02", title: "Data Science", icon: "DS" },
    { number: "03", title: "Cloud & DevOps", icon: "CL" },
    { number: "04", title: "Cybersecurity", icon: "CY" },
];

const ArrowIcon = ({ className = "h-4 w-4" }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className={className} aria-hidden="true">
        <path d="M5 12h14M13 6l6 6-6 6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const EngineeringArrow = ArrowIcon;

const HeroButton = ({ href, children, variant = "primary", dark = false }) => {
    const classes =
        variant === "primary"
            ? "bg-[#D5AD57] text-[#071A2F] hover:bg-white"
            : dark
                ? "border border-white/25 text-white hover:border-[#D5AD57] hover:text-[#D5AD57]"
                : "border border-[#071A2F]/20 text-[#071A2F] hover:border-[#8B1E3F] hover:text-[#8B1E3F]";

    return (
        <a
            href={href}
            className={`inline-flex min-h-[52px] items-center justify-center gap-4 rounded-full px-6 text-sm font-bold transition duration-300 hover:-translate-y-1 focus:outline-none focus:ring-2 focus:ring-[#D5AD57] focus:ring-offset-2 ${classes}`}
        >
            {children}
            <ArrowIcon />
        </a>
    );
};

const Breadcrumb = ({ current, dark = false }) => (
    <nav aria-label="Breadcrumb" className={`flex flex-wrap items-center gap-3 text-sm font-semibold ${dark ? "text-white/55" : "text-[#65717D]"}`}>
        <a href="/" className={dark ? "hover:text-[#D5AD57]" : "hover:text-[#8B1E3F]"}>Home</a>
        <span>/</span>
        <a href="/schools" className={dark ? "hover:text-[#D5AD57]" : "hover:text-[#8B1E3F]"}>Schools</a>
        <span>/</span>
        <span className={dark ? "text-white" : "text-[#071A2F]"}>{current}</span>
    </nav>
);

const Eyebrow = ({ children, dark = false }) => (
    <div className={`flex items-center gap-3 text-sm font-extrabold uppercase tracking-[0.16em] ${dark ? "text-[#D5AD57]" : "text-[#8B1E3F]"}`}>
        <span className="h-px w-10 bg-current" />
        <span>{children}</span>
    </div>
);

const Metric = ({ value, label, dark = false }) => (
    <div className={`border-l pl-4 ${dark ? "border-white/15" : "border-[#071A2F]/15"}`}>
        <strong className={`block font-['Libre_Caslon_Display',Georgia,serif] text-2xl font-normal ${dark ? "text-white" : "text-[#071A2F]"}`}>{value}</strong>
        <span className={`mt-1 block text-sm leading-5 ${dark ? "text-white/55" : "text-[#65717D]"}`}>{label}</span>
    </div>
);

export function SchoolOfManagementHero({
    image = SchoolofManagementImage,
    exploreHref = "#programmes",
    applyHref = "/apply-online",
}) {
    const stats = [
        ["8+", "Industry-Aligned Management Programmes"],
        ["50+", "Top Corporate Recruiting Partners"],
        ["9+", "National & International Recognitions"],
        ["100%", "Placement Support"],
    ];

    return (
        <section
            id="overview"
            aria-labelledby="management-hero-heading"
            className="relative isolate flex min-h-[790px] items-center overflow-hidden text-white max-[850px]:min-h-[900px] max-[850px]:items-start max-[620px]:min-h-[940px]"
        >
            <img
                src={image}
                alt="University management campus"
                className="absolute inset-0 -z-30 h-full w-full object-cover"
            />

            <div className="absolute inset-0 -z-20 bg-[linear-gradient(90deg,rgba(4,18,36,0.97)_0%,rgba(5,24,46,0.84)_45%,rgba(5,24,46,0.28)_76%,rgba(5,24,46,0.22)_100%),linear-gradient(0deg,rgba(4,18,36,0.7)_0%,transparent_44%)]" />

            <div className="mx-auto w-[min(1280px,calc(100%-48px))] py-[110px] pb-[180px] max-[850px]:w-[min(700px,calc(100%-32px))] max-[850px]:pt-[100px] max-[620px]:w-[calc(100%-28px)] max-[620px]:py-[80px] max-[620px]:pb-[260px]">
                <nav
                    aria-label="Breadcrumb"
                    className="mb-[55px] flex flex-wrap gap-2.5 text-xs text-white/60 max-[850px]:mb-10"
                >
                    <a href="/" className="transition hover:text-[#D5AD57]">Home</a>
                    <span>/</span>
                    <a href="/schools" className="transition hover:text-[#D5AD57]">Schools</a>
                    <span>/</span>
                    <strong className="font-semibold text-white">Management</strong>
                </nav>

                <div className="inline-flex items-center gap-3 text-xs font-bold uppercase tracking-[0.16em] text-[#E5B652] before:h-0.5 before:w-[35px] before:bg-current before:content-['']">
                    School of
                </div>

                <h1
                    id="management-hero-heading"
                    className="my-5 max-w-[850px] font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(59px,7.5vw,112px)] font-normal leading-[0.89] tracking-[-0.055em] max-[620px]:text-[58px]"
                >
                    Management
                </h1>

                <p className="mb-[37px] max-w-[690px] text-lg leading-[1.75] text-white/80 max-[620px]:text-[15px]">
                    Welcome to the School of Management at ISBM University! Our goal is to provide students with a comprehensive education in business and management, equipping them with the knowledge and skills needed to succeed in today&apos;s global business environment.
                </p>

                <div className="flex flex-wrap gap-3.5 max-[620px]:w-full max-[620px]:flex-col">
                    <a
                        href={applyHref}
                        className="inline-flex min-h-[54px] items-center justify-center gap-[22px] rounded-full border border-transparent bg-[#8B1E3F] px-[25px] text-sm font-bold text-white shadow-[0_16px_38px_rgba(139,30,63,0.28)] transition duration-300 hover:-translate-y-[3px] hover:bg-[#6F1732] max-[620px]:w-full"
                    >
                        Apply for Admission <span className="text-lg">↗</span>
                    </a>

                    <a
                        href={exploreHref}
                        className="inline-flex min-h-[54px] items-center justify-center gap-[22px] rounded-full border border-white/40 bg-white/[0.08] px-[25px] text-sm font-bold text-white backdrop-blur-[10px] transition duration-300 hover:-translate-y-[3px] hover:border-[#D5AD57] hover:text-[#D5AD57] max-[620px]:w-full"
                    >
                        Explore Programmes <span className="text-lg">↓</span>
                    </a>
                </div>
            </div>

            <div className="absolute bottom-0 right-0 left-[max(24px,calc((100vw-1280px)/2))] grid grid-cols-4 gap-[25px] bg-white/95 py-[30px] pr-[6vw] pl-[45px] text-[#071A2F] shadow-[0_25px_70px_rgba(7,27,51,0.14)] backdrop-blur-[15px] max-[1100px]:grid-cols-2 max-[850px]:left-4 max-[620px]:right-3.5 max-[620px]:left-3.5 max-[620px]:gap-x-2.5 max-[620px]:gap-y-[18px] max-[620px]:p-5">
                {stats.map(([value, label]) => (
                    <div key={label} className="border-l border-[#DDE2E8] pl-6 max-[620px]:pl-3">
                        <strong className="block font-['Libre_Caslon_Display',Georgia,serif] text-[38px] font-normal text-[#8B1E3F] max-[620px]:text-[29px]">
                            {value}
                        </strong>
                        <span className="text-xs leading-5 text-[#6B7480]">{label}</span>
                    </div>
                ))}
            </div>
        </section>
    );
}

export function SchoolOfCommerceHero({
    image = SchoolofCommerceImage,
    exploreHref = "#academic-programs",
    applyHref = "/apply-online",
}) {
    return (
        <section className="relative min-h-[840px] overflow-hidden bg-[#071A2F] text-white">
            <div className="absolute inset-0">
                <img src={image} alt="Commerce students in a professional business learning environment" className="h-full w-full object-cover object-center" />
                <div className="absolute inset-0 bg-[linear-gradient(90deg,rgba(7,26,47,0.99)_0%,rgba(7,26,47,0.96)_48%,rgba(7,26,47,0.55)_100%)]" />
                <div className="absolute inset-0 opacity-[0.06] [background-image:linear-gradient(rgba(255,255,255,.35)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,.35)_1px,transparent_1px)] [background-size:80px_80px]" />
            </div>

            <div className="relative mx-auto grid min-h-[840px] w-[min(1440px,calc(100%-48px))] items-center gap-12 py-28 max-sm:w-[calc(100%-28px)] lg:grid-cols-[1.1fr_0.7fr]">
                <div>
                    <nav className="flex flex-wrap items-center gap-3 text-sm font-semibold uppercase tracking-[0.12em] text-white/55" aria-label="Breadcrumb">
                        <a href="/" className="hover:text-[#D5AD57]">Home</a><span>/</span><a href="/schools" className="hover:text-[#D5AD57]">Schools</a><span>/</span><span className="text-white">Commerce</span>
                    </nav>
                    <div className="mt-12 flex items-center gap-4 text-sm font-extrabold uppercase tracking-[0.16em] text-[#D5AD57]"><span className="h-px w-12 bg-current" />School of Commerce</div>
                    <h1 className="mt-7 max-w-5xl font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(56px,7.5vw,108px)] font-normal leading-[0.94] tracking-[-0.055em]">
                        Commerce for a world shaped by <em className="block font-normal text-[#D5AD57]">capital, data and ideas.</em>
                    </h1>
                    <p className="mt-8 max-w-3xl text-base leading-8 text-white/70 sm:text-lg">
                        Build financial intelligence, commercial judgement and enterprise capability for careers in accounting, banking, taxation, analytics, entrepreneurship and global business.
                    </p>
                    <div className="mt-10 flex flex-wrap gap-4">
                        <a href="#academic-programs" className="inline-flex min-h-14 items-center gap-6 bg-[#D5AD57] px-7 text-sm font-extrabold uppercase tracking-[0.08em] text-[#071A2F] transition hover:-translate-y-1 hover:bg-white">Explore programmes <span>↗</span></a>
                        <a href="/apply-online" className="inline-flex min-h-14 items-center gap-6 border border-white/30 px-7 text-sm font-extrabold uppercase tracking-[0.08em] text-white transition hover:border-[#D5AD57] hover:text-[#D5AD57]">Apply now <span>→</span></a>
                    </div>
                </div>

                <aside className="hidden border-y border-white/25 lg:block">
                    <div className="flex items-end justify-between border-b border-white/20 py-6">
                        <span className="text-sm font-bold uppercase tracking-[0.14em] text-[#D5AD57]">Commerce index</span>
                    </div>
                    {[
                        ["01", "Accounting & Finance", "Interpret value and performance"],
                        ["02", "Banking & Taxation", "Understand systems and compliance"],
                        ["03", "Analytics & Digital Commerce", "Turn information into decisions"],
                        ["04", "Entrepreneurship", "Build sustainable enterprise"],
                    ].map(([n, title, text]) => (
                        <div key={n} className="grid grid-cols-[44px_1fr] gap-5 border-b border-white/20 py-6 last:border-b-0">
                            <span className="text-sm font-extrabold text-[#D5AD57]">{n}</span>
                            <div><strong className="font-['Libre_Caslon_Display',Georgia,serif] text-2xl font-normal">{title}</strong><p className="mt-2 text-sm leading-6 text-white/50">{text}</p></div>
                        </div>
                    ))}
                </aside>
            </div>
        </section>
    );
}

export function SchoolOfEngineeringTechnologyHero({
    image = SchoolofEngineeringandTechnologyImage,
    exploreHref = "#academic-programs",
    applyHref = "/apply-online",
}) {
    return (
        <section
            className="relative isolate min-h-[820px] overflow-hidden bg-[#071A2F] text-white lg:min-h-[900px]"
            aria-labelledby="engineering-hero-heading"
        >
            <div className="pointer-events-none absolute inset-0 -z-10">
                <div className="absolute inset-0 bg-[radial-gradient(circle_at_80%_30%,rgba(12,39,68,0.95),transparent_42%),linear-gradient(135deg,#071A2F_0%,#0C2744_50%,#071A2F_100%)]" />

                <div className="absolute -left-40 top-[-20%] h-[620px] w-[620px] rounded-full bg-[#8B1E3F]/15 blur-[140px]" />

                <div className="absolute bottom-[-35%] right-[-10%] h-[720px] w-[720px] rounded-full bg-[#D5AD57]/10 blur-[150px]" />

                {/* Digital grid */}
                <div
                    className="absolute inset-0 opacity-[0.055]"
                    style={{
                        backgroundImage:
                            "linear-gradient(rgba(213,173,87,0.7) 1px, transparent 1px), linear-gradient(90deg, rgba(213,173,87,0.7) 1px, transparent 1px)",
                        backgroundSize: "64px 64px",
                        maskImage:
                            "linear-gradient(to bottom, transparent, black 20%, black 80%, transparent)",
                        WebkitMaskImage:
                            "linear-gradient(to bottom, transparent, black 20%, black 80%, transparent)",
                    }}
                />

                {/* Blueprint circuit lines */}
                <svg
                    viewBox="0 0 1600 900"
                    fill="none"
                    className="absolute inset-0 h-full w-full opacity-[0.09]"
                    aria-hidden="true"
                >
                    <path
                        d="M0 170h220l90 90h230l85-85h260l110 110h390l100-100h135"
                        stroke="#D5AD57"
                        strokeWidth="1.5"
                    />

                    <path
                        d="M0 700h180l110-110h300l100 100h260l120-120h350l180 180"
                        stroke="#FFFFFF"
                        strokeWidth="1"
                    />

                    <path
                        d="M310 260v160l85 85M625 175v-145M975 285v160M1070 570v-170"
                        stroke="#D5AD57"
                        strokeWidth="1.2"
                    />

                    {[
                        [220, 170],
                        [310, 260],
                        [540, 260],
                        [625, 175],
                        [885, 175],
                        [975, 285],
                        [290, 590],
                        [690, 690],
                        [1070, 570],
                        [1420, 570],
                    ].map(([cx, cy]) => (
                        <g key={`${cx}-${cy}`}>
                            <circle cx={cx} cy={cy} r="7" fill="#D5AD57" />
                            <circle
                                cx={cx}
                                cy={cy}
                                r="15"
                                stroke="#D5AD57"
                                strokeWidth="1"
                            />
                        </g>
                    ))}
                </svg>

                {/* Floating particles */}
                {[
                    ["left-[8%]", "top-[24%]", "delay-0"],
                    ["left-[19%]", "top-[72%]", "delay-300"],
                    ["left-[48%]", "top-[15%]", "delay-700"],
                    ["right-[34%]", "top-[68%]", "delay-500"],
                    ["right-[8%]", "top-[18%]", "delay-1000"],
                    ["right-[13%]", "bottom-[12%]", "delay-200"],
                ].map(([x, y, delay], index) => (
                    <span
                        key={index}
                        className={`absolute ${x} ${y} ${delay} h-1.5 w-1.5 animate-pulse rounded-full bg-[#D5AD57] shadow-[0_0_18px_rgba(213,173,87,0.9)] motion-reduce:animate-none`}
                    />
                ))}
            </div>

            {/* ===
          MAIN CONTENT
      ==== */}
            <div className="mx-auto flex min-h-[820px] max-w-[1440px] items-center px-5 py-28 sm:px-8 lg:min-h-[900px] lg:px-10 lg:py-32">
                <div className="grid w-full items-center gap-16 lg:grid-cols-[0.88fr_1.12fr] xl:gap-20">
                    {/* =
              LEFT CONTENT
          == */}
                    <div className="relative z-20">
                        <div className="inline-flex items-center gap-3 rounded-full border border-white/15 bg-white/[0.07] px-4 py-2.5 backdrop-blur-xl">
                            <span className="relative flex h-2.5 w-2.5">
                                <span className="absolute h-full w-full animate-ping rounded-full bg-[#D5AD57] opacity-70 motion-reduce:animate-none" />
                                <span className="relative h-2.5 w-2.5 rounded-full bg-[#D5AD57]" />
                            </span>

                            <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-[#D5AD57] sm:text-xs">
                                School of Engineering &amp; Technology
                            </span>
                        </div>

                        <h1
                            id="engineering-hero-heading"
                            className="mt-7 max-w-3xl text-[clamp(48px,6vw,84px)] font-normal leading-[0.98] tracking-[-0.05em] text-white"
                            style={{
                                fontFamily: '"Libre Caslon Display", Georgia, serif',
                            }}
                        >
                            Engineering ideas
                            <span className="block text-white">that shape the</span>
                            <span className="block italic text-[#D5AD57]">
                                future of our world.
                            </span>
                        </h1>

                        <p className="mt-7 max-w-2xl text-base leading-8 text-white/65 sm:text-lg sm:leading-9">
                            Develop the scientific knowledge, technical intelligence and
                            innovative mindset required to solve complex challenges across
                            engineering, Artificial Intelligence, robotics, infrastructure,
                            intelligent systems and sustainable technology.
                        </p>

                        {/* Domain ticker */}
                        <div className="mt-8 flex max-w-2xl flex-wrap gap-2.5">
                            {engineeringDomains.map((domain) => (
                                <span
                                    key={domain}
                                    className="rounded-full border border-white/10 bg-white/[0.045] px-4 py-2 text-[10px] font-semibold uppercase tracking-[0.12em] text-white/65 backdrop-blur transition duration-300 hover:border-[#D5AD57]/50 hover:bg-[#D5AD57]/10 hover:text-[#D5AD57]"
                                >
                                    {domain}
                                </span>
                            ))}
                        </div>

                        {/* CTA buttons */}
                        <div className="mt-10 flex flex-col gap-4 sm:flex-row">
                            <a
                                href="#engineering-programmes"
                                className="group inline-flex items-center justify-center gap-3 rounded-full bg-[#D5AD57] px-8 py-4 text-sm font-bold text-[#071A2F] hover:text-[#071A2F] shadow-[0_18px_45px_rgba(213,173,87,0.22)] transition duration-300 hover:-translate-y-1 hover:bg-white hover:shadow-[0_22px_55px_rgba(213,173,87,0.30)]"
                            >
                                Explore programmes

                                <span className="transition duration-300 group-hover:translate-x-1">
                                    <EngineeringArrow />
                                </span>
                            </a>

                            <a
                                href="/apply-online"
                                className="group inline-flex items-center justify-center gap-3 rounded-full border border-white/20 bg-white/[0.06] px-8 py-4 text-sm font-bold text-white backdrop-blur transition duration-300 hover:-translate-y-1 hover:border-white hover:bg-white hover:text-[#071A2F]"
                            >
                                Apply for admission

                                <span className="transition duration-300 group-hover:translate-x-1">
                                    <EngineeringArrow />
                                </span>
                            </a>
                        </div>

                        {/* Highlights */}
                        <div className="mt-12 grid max-w-3xl grid-cols-2 gap-px overflow-hidden rounded-2xl border border-white/10 bg-white/10 sm:grid-cols-4">
                            {engineeringHighlights.map((highlight) => (
                                <div
                                    key={highlight.label}
                                    className="group bg-[#071A2F]/85 p-4 backdrop-blur transition duration-300 hover:bg-white/[0.08] sm:p-5"
                                >
                                    <strong
                                        className="block text-2xl font-normal text-[#D5AD57] sm:text-3xl"
                                        style={{
                                            fontFamily: '"Libre Caslon Display", Georgia, serif',
                                        }}
                                    >
                                        {highlight.value}
                                    </strong>

                                    <span className="mt-2 block text-[10px] font-semibold uppercase leading-5 tracking-[0.12em] text-white/45">
                                        {highlight.label}
                                    </span>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* =
              RIGHT ENGINEERING VISUAL
          == */}
                    <div className="relative mx-auto w-full max-w-[760px] lg:mx-0">
                        {/* Outer orbit */}
                        <div className="absolute left-1/2 top-1/2 h-[92%] w-[92%] -translate-x-1/2 -translate-y-1/2 rounded-full border border-[#D5AD57]/15" />

                        <div className="absolute left-1/2 top-1/2 h-[72%] w-[72%] -translate-x-1/2 -translate-y-1/2 animate-[spin_35s_linear_infinite] rounded-full border border-dashed border-white/10 motion-reduce:animate-none">
                            <span className="absolute -top-1 left-1/2 h-2.5 w-2.5 -translate-x-1/2 rounded-full bg-[#D5AD57] shadow-[0_0_20px_rgba(213,173,87,0.9)]" />
                            <span className="absolute -bottom-1 left-1/2 h-2 w-2 -translate-x-1/2 rounded-full bg-white/80" />
                        </div>

                        {/* Main image frame */}
                        <div className="relative mx-auto h-[560px] w-[88%] overflow-hidden rounded-[34px] border border-white/15 bg-[#0C2744] shadow-[0_45px_110px_rgba(0,0,0,0.45)] sm:h-[650px] lg:h-[700px]">
                            <img
                                src={image}
                                alt="Engineering students working in an advanced innovation and technology laboratory"
                                className="h-full w-full object-cover"
                            />

                            <div className="absolute inset-0 bg-gradient-to-t from-[#071A2F] via-[#071A2F]/15 to-[#0C2744]/15" />

                            <div className="absolute inset-0 bg-gradient-to-r from-[#071A2F]/35 via-transparent to-[#071A2F]/10" />

                            {/* Scanning line */}
                            <div className="absolute inset-x-0 top-[34%] h-px bg-gradient-to-r from-transparent via-[#D5AD57]/70 to-transparent shadow-[0_0_20px_rgba(213,173,87,0.65)]" />

                            {/* Image label */}
                            <div className="absolute bottom-7 left-7 right-7">
                                <div className="flex flex-col gap-5 rounded-2xl border border-white/15 bg-[#071A2F]/65 p-5 backdrop-blur-xl sm:flex-row sm:items-end sm:justify-between">
                                    <div>
                                        <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-[#D5AD57]">
                                            Engineering innovation laboratory
                                        </span>

                                        <strong
                                            className="mt-2 block text-2xl font-normal text-white"
                                            style={{
                                                fontFamily:
                                                    '"Libre Caslon Display", Georgia, serif',
                                            }}
                                        >
                                            Design. Build. Test. Transform.
                                        </strong>
                                    </div>

                                    <div className="flex items-center gap-2">
                                        {[1, 2, 3, 4].map((item) => (
                                            <span
                                                key={item}
                                                className={`rounded-full ${item === 2
                                                    ? "h-3 w-3 bg-[#D5AD57]"
                                                    : "h-2 w-2 bg-white/30"
                                                    }`}
                                            />
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* AI / Robotics card */}
                        <div className="absolute -left-1 top-[12%] max-w-[190px] animate-[pulse_4s_ease-in-out_infinite] rounded-2xl border border-white/15 bg-[#071A2F]/75 p-4 shadow-[0_22px_50px_rgba(0,0,0,0.35)] backdrop-blur-xl motion-reduce:animate-none sm:-left-8">
                            <div className="flex items-center gap-3">
                                <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-[#D5AD57]/15 text-[#D5AD57]">
                                    <svg
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="1.6"
                                        className="h-5 w-5"
                                        aria-hidden="true"
                                    >
                                        <rect x="5" y="7" width="14" height="11" rx="3" />
                                        <path d="M9 12h.01M15 12h.01M9 15h6M12 7V4M10 4h4" />
                                    </svg>
                                </span>

                                <div>
                                    <span className="block text-[9px] font-bold uppercase tracking-[0.16em] text-[#D5AD57]">
                                        Intelligent systems
                                    </span>
                                    <strong className="mt-1 block text-xs text-white">
                                        AI &amp; Robotics
                                    </strong>
                                </div>
                            </div>

                            <div className="mt-4 flex h-9 items-end gap-1">
                                {[35, 55, 42, 75, 60, 88, 67, 95].map((height, index) => (
                                    <span
                                        key={index}
                                        className="flex-1 rounded-sm bg-gradient-to-t from-[#8B1E3F] to-[#D5AD57]"
                                        style={{ height: `${height}%` }}
                                    />
                                ))}
                            </div>
                        </div>

                        {/* CAD card */}
                        <div className="absolute -right-1 top-[7%] w-[180px] rounded-2xl border border-white/15 bg-[#071A2F]/75 p-4 shadow-[0_22px_50px_rgba(0,0,0,0.35)] backdrop-blur-xl sm:-right-7">
                            <div className="flex items-center justify-between">
                                <div>
                                    <span className="block text-[9px] font-bold uppercase tracking-[0.16em] text-[#D5AD57]">
                                        Digital engineering
                                    </span>
                                    <strong className="mt-1 block text-xs text-white">
                                        CAD Simulation
                                    </strong>
                                </div>

                                <span className="h-2 w-2 animate-pulse rounded-full bg-emerald-400 shadow-[0_0_12px_rgba(52,211,153,0.8)] motion-reduce:animate-none" />
                            </div>

                            <div className="relative mx-auto mt-4 flex h-16 w-16 items-center justify-center">
                                <div className="absolute inset-0 animate-[spin_14s_linear_infinite] rounded-full border border-dashed border-[#D5AD57]/50 motion-reduce:animate-none" />
                                <div className="h-8 w-8 rotate-45 border border-white/45 bg-white/[0.05]" />
                            </div>
                        </div>

                        {/* Industry 4.0 card */}
                        <div className="absolute -right-1 top-[42%] w-[195px] rounded-2xl border border-white/15 bg-[#071A2F]/75 p-4 shadow-[0_22px_50px_rgba(0,0,0,0.35)] backdrop-blur-xl sm:-right-10">
                            <div className="flex items-center justify-between">
                                <span className="text-[9px] font-bold uppercase tracking-[0.16em] text-[#D5AD57]">
                                    Industry 4.0
                                </span>
                                <span className="text-[9px] text-emerald-400">ONLINE</span>
                            </div>

                            <div className="mt-4 grid grid-cols-3 gap-2">
                                {["IoT", "Auto", "Smart"].map((item, index) => (
                                    <div
                                        key={item}
                                        className="rounded-lg border border-white/10 bg-white/[0.05] p-2 text-center"
                                    >
                                        <span
                                            className={`mx-auto block h-1.5 w-1.5 rounded-full ${index === 1
                                                ? "bg-[#D5AD57]"
                                                : "bg-emerald-400"
                                                }`}
                                        />
                                        <span className="mt-2 block text-[8px] font-bold text-white/60">
                                            {item}
                                        </span>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Sustainable engineering card */}
                        <div className="absolute -bottom-4 right-[5%] w-[210px] rounded-2xl border border-[#D5AD57]/30 bg-[#F7F2E8] p-4 text-[#071A2F] shadow-[0_24px_55px_rgba(0,0,0,0.30)] sm:-right-5">
                            <div className="flex items-center gap-3">
                                <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-[#071A2F] text-[#D5AD57]">
                                    <svg
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="1.6"
                                        className="h-5 w-5"
                                        aria-hidden="true"
                                    >
                                        <path d="M12 21V10M12 13c-4 0-7-2.5-7-7 4 0 7 2.5 7 7ZM12 16c4 0 7-2.5 7-7-4 0-7 2.5-7 7Z" />
                                    </svg>
                                </span>

                                <div>
                                    <span className="block text-[9px] font-bold uppercase tracking-[0.15em] text-[#8B1E3F]">
                                        Sustainable systems
                                    </span>
                                    <strong className="mt-1 block text-xs">
                                        Engineering for impact
                                    </strong>
                                </div>
                            </div>
                        </div>

                        {/* Research status */}
                        <div className="absolute -bottom-5 left-[3%] rounded-full border border-white/15 bg-[#071A2F]/80 px-5 py-3 shadow-xl backdrop-blur-xl sm:-left-3">
                            <span className="flex items-center gap-3 text-[10px] font-bold uppercase tracking-[0.14em] text-white/70">
                                <span className="h-2 w-2 animate-pulse rounded-full bg-[#D5AD57] shadow-[0_0_14px_rgba(213,173,87,0.9)] motion-reduce:animate-none" />
                                Research in progress
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            {/* Bottom discipline ribbon */}
            <div className="absolute inset-x-0 bottom-0 z-20 border-t border-white/10 bg-[#071A2F]/80 backdrop-blur-xl">
                <div className="mx-auto flex max-w-[1440px] items-center overflow-hidden px-5 sm:px-8 lg:px-10">
                    <div className="flex shrink-0 items-center gap-3 border-r border-white/10 py-4 pr-6">
                        <span className="h-2 w-2 rounded-full bg-[#D5AD57]" />
                        <span className="text-[9px] font-bold uppercase tracking-[0.2em] text-[#D5AD57]">
                            Engineering domains
                        </span>
                    </div>

                    <div className="custom-scroll flex min-w-0 flex-1 items-center gap-8 overflow-x-auto py-4 pl-6">
                        {[
                            "Artificial Intelligence",
                            "Computer Science",
                            "Mechanical Systems",
                            "Civil Infrastructure",
                            "Electrical Engineering",
                            "Electronics",
                            "Robotics",
                            "Renewable Energy",
                        ].map((domain) => (
                            <span
                                key={domain}
                                className="shrink-0 text-[10px] font-semibold uppercase tracking-[0.13em] text-white/40 transition hover:text-white"
                            >
                                {domain}
                            </span>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}

export function SchoolOfInformationTechnologyHero({
    image = SchoolofInformationandTechnologyImage,
    exploreHref = "#academic-programs",
    applyHref = "/apply-online",
}) {
    return (
        <section
            className="relative isolate min-h-screen overflow-hidden bg-[#050F1F] text-white"
            aria-labelledby="it-future-heading"
        >
            {/* Layered institutional background */}
            <div className="pointer-events-none absolute inset-0 -z-20">
                <div className="absolute inset-0 bg-[radial-gradient(circle_at_76%_35%,rgba(67,112,255,0.20),transparent_28%),radial-gradient(circle_at_59%_70%,rgba(139,30,63,0.24),transparent_31%),linear-gradient(120deg,#050F1F_0%,#071A2F_52%,#0C2744_100%)]" />
                <div className="absolute inset-0 opacity-20 bg-[linear-gradient(rgba(255,255,255,0.055)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.055)_1px,transparent_1px)] bg-[size:64px_64px]" />
                <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[#D5AD57]/70 to-transparent" />
            </div>

            {/* Neural network spread across the hero */}
            <svg
                className="pointer-events-none absolute inset-0 -z-10 h-full w-full opacity-40"
                viewBox="0 0 1600 900"
                preserveAspectRatio="none"
                aria-hidden="true"
            >
                <defs>
                    <linearGradient id="networkLine" x1="0" y1="0" x2="1" y2="0">
                        <stop offset="0" stopColor="#D5AD57" stopOpacity="0" />
                        <stop offset=".45" stopColor="#5D85FF" stopOpacity=".42" />
                        <stop offset="1" stopColor="#8B1E3F" stopOpacity=".18" />
                    </linearGradient>
                </defs>
                <g fill="none" stroke="url(#networkLine)" strokeWidth="1">
                    <path d="M130 166 430 75l250 132 312-115 291 145" />
                    <path d="m110 430 350 90 258-145 292 168 430-178" />
                    <path d="m270 760 265-104 301 122 295-142 290 110" />
                    <path d="m430 75 30 445 75 136M680 207l38 168 118 403M992 92l18 451 121 93M1283 237l-152 399" />
                </g>
            </svg>

            {networkNodes.map(([left, top], index) => (
                <span
                    key={`${left}-${top}`}
                    className={[
                        "pointer-events-none absolute -z-10 h-1.5 w-1.5 rounded-full",
                        index % 3 === 0
                            ? "bg-[#D5AD57] shadow-[0_0_18px_#D5AD57]"
                            : "bg-blue-400 shadow-[0_0_16px_#60A5FA]",
                    ].join(" ")}
                    style={{ left, top }}
                    aria-hidden="true"
                />
            ))}

            {/* Vertical research label */}
            <aside className="absolute inset-y-0 left-0 z-20 hidden w-14 border-r border-white/10 xl:flex xl:flex-col xl:items-center xl:justify-between xl:py-9">
                <span className="text-[9px] font-bold uppercase tracking-[0.22em] text-[#D5AD57] [writing-mode:vertical-rl]">
                    School of Information Technology
                </span>
                <span className="h-20 w-px bg-gradient-to-b from-[#D5AD57] to-transparent" />
                <span className="font-mono text-[9px] text-white/35 [writing-mode:vertical-rl]">
                    ISBM · FUTURE SYSTEMS
                </span>
            </aside>

            <div className="mx-auto grid min-h-screen max-w-[1720px] grid-cols-1 lg:grid-cols-[52%_48%] xl:pl-14">
                {/* Content */}
                <div className="relative z-20 flex items-center px-5 pb-16 pt-24 sm:px-8 md:px-12 lg:px-14 lg:py-24 xl:px-20">
                    <div className="w-full max-w-[820px]">
                        <div className="mb-9 flex flex-wrap items-center gap-4">
                            <span className="inline-flex items-center gap-3 border border-[#D5AD57]/30 bg-white/[0.055] px-4 py-2 text-[10px] font-bold uppercase tracking-[0.18em] text-[#D5AD57] backdrop-blur-xl">
                                <span className="relative flex h-2 w-2">
                                    <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#D5AD57] opacity-60" />
                                    <span className="relative inline-flex h-2 w-2 rounded-full bg-[#D5AD57]" />
                                </span>
                                School of Information &amp; Technology
                            </span>
                            <span className="font-mono text-[9px] uppercase tracking-[0.16em] text-white/35">
                                Research Node / 01
                            </span>
                        </div>

                        <p className="mb-5 flex items-center gap-3 text-[10px] font-semibold uppercase tracking-[0.26em] text-blue-300/80">
                            <span className="h-px w-12 bg-blue-400/70" />
                            Computing · Intelligence · Impact
                        </p>

                        <h1
                            id="it-future-heading"
                            className="max-w-[780px] font-serif text-[clamp(3.5rem,6vw,7rem)] font-normal leading-[0.88] tracking-[-0.055em]"
                        >
                            Invent the systems{" "}
                            <span className="relative mt-2 inline-block text-transparent [-webkit-text-stroke:1px_rgba(213,173,87,0.9)]">
                                shaping tomorrow.
                                <span
                                    className="absolute -bottom-3 left-1 h-px w-2/3 bg-gradient-to-r from-[#D5AD57] via-blue-400 to-transparent"
                                    aria-hidden="true"
                                />
                            </span>
                        </h1>

                        <p className="mt-10 max-w-[670px] border-l border-[#D5AD57]/55 pl-5 text-[15px] leading-7 text-slate-300 sm:text-base sm:leading-8">
                            An advanced academic environment for artificial intelligence,
                            machine learning, data science, software engineering, cloud
                            computing and secure digital systems—where research becomes
                            technology with real-world impact.
                        </p>

                        <div className="mt-9 flex flex-col gap-3 sm:flex-row">
                            <a
                                href="#programmes"
                                className="group inline-flex min-h-14 items-center justify-between gap-10 bg-[#D5AD57] px-6 text-sm font-bold text-[#071A2F] shadow-[0_18px_45px_rgba(213,173,87,0.18)] transition duration-300 hover:-translate-y-1 hover:bg-[#E1C173] focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-[#071A2F]"
                            >
                                Explore Programmes
                                <span className="transition-transform duration-300 group-hover:translate-x-1">
                                    <Arrow />
                                </span>
                            </a>

                            <a
                                href="/apply-online"
                                className="group inline-flex min-h-14 items-center justify-between gap-10 border border-white/20 bg-white/[0.055] px-6 text-sm font-semibold text-white backdrop-blur-lg transition duration-300 hover:-translate-y-1 hover:border-[#D5AD57]/60 hover:bg-white/10 focus:outline-none focus:ring-2 focus:ring-[#D5AD57]"
                            >
                                Begin Your Application
                                <span className="transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5">
                                    <Arrow diagonal />
                                </span>
                            </a>
                        </div>

                        {/* Programme focus strip */}
                        <div className="mt-12 grid grid-cols-2 border-y border-white/10 xl:grid-cols-4">
                            {focusAreas.map((area, index) => (
                                <a
                                    href="#programmes"
                                    key={area.title}
                                    className={[
                                        "group relative min-h-28 overflow-hidden border-white/10 px-4 py-5 transition duration-300 hover:bg-white/[0.07]",
                                        index < 3 ? "xl:border-r" : "",
                                        index % 2 === 0 ? "border-r xl:border-r" : "",
                                        index < 2 ? "border-b xl:border-b-0" : "",
                                    ].join(" ")}
                                >
                                    <span className="absolute right-3 top-3 font-mono text-[8px] text-white/25">
                                        {area.number}
                                    </span>
                                    <span className="mb-4 block text-[#D5AD57] transition duration-300 group-hover:text-blue-300">
                                        {area.icon}
                                    </span>
                                    <strong className="block max-w-[120px] text-[11px] font-semibold leading-4 text-white/75 transition group-hover:text-white">
                                        {area.title}
                                    </strong>
                                </a>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Cinematic technology visual */}
                <div className="relative min-h-[720px] overflow-hidden lg:min-h-screen">
                    <img
                        src={image}
                        alt="Advanced AI humanoid robot in a university information technology research laboratory"
                        className="absolute inset-0 h-full w-full scale-[1.03] object-cover object-center saturate-[0.88]"
                    />

                    {/* Blend image into the hero */}
                    <div className="absolute inset-0 bg-gradient-to-r from-[#050F1F] via-[#071A2F]/30 to-transparent" />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#050F1F] via-transparent to-[#050F1F]/35" />
                    <div className="absolute inset-0 bg-blue-950/10 mix-blend-color" />

                    {/* Research interface frame */}
                    <div className="absolute inset-5 border border-white/10 sm:inset-8 lg:inset-x-10 lg:inset-y-12">
                        <span className="absolute -left-px -top-px h-8 w-8 border-l border-t border-[#D5AD57]" />
                        <span className="absolute -right-px -top-px h-8 w-8 border-r border-t border-[#D5AD57]" />
                        <span className="absolute -bottom-px -left-px h-8 w-8 border-b border-l border-[#D5AD57]" />
                        <span className="absolute -bottom-px -right-px h-8 w-8 border-b border-r border-[#D5AD57]" />
                    </div>

                    {/* Holographic AI model panel */}
                    <div className="absolute right-5 top-8 w-[min(72%,320px)] border border-blue-300/20 bg-[#071A2F]/55 p-4 shadow-[0_25px_70px_rgba(0,0,0,0.30)] backdrop-blur-xl sm:right-10 sm:top-14">
                        <div className="mb-4 flex items-center justify-between border-b border-white/10 pb-3">
                            <span className="font-mono text-[8px] uppercase tracking-[0.18em] text-blue-200/70">
                                Neural Intelligence Model
                            </span>
                            <span className="flex gap-1">
                                <i className="h-1 w-1 rounded-full bg-[#D5AD57]" />
                                <i className="h-1 w-1 rounded-full bg-blue-400" />
                                <i className="h-1 w-1 rounded-full bg-[#8B1E3F]" />
                            </span>
                        </div>
                        <svg viewBox="0 0 280 120" className="h-28 w-full" aria-hidden="true">
                            <g stroke="rgba(147,197,253,.35)" strokeWidth="1">
                                <path d="M20 27 88 14l49 40 59-29 62 38M20 27l46 70 71-43 53 51 68-42M88 14 66 97M137 54l53 51M196 25l-6 80" />
                            </g>
                            {[
                                [20, 27], [88, 14], [137, 54], [196, 25], [258, 63],
                                [66, 97], [190, 105],
                            ].map(([cx, cy], index) => (
                                <circle
                                    key={`${cx}-${cy}`}
                                    cx={cx}
                                    cy={cy}
                                    r={index === 2 ? 6 : 4}
                                    fill={index === 2 ? "#D5AD57" : "#60A5FA"}
                                />
                            ))}
                        </svg>
                        <div className="grid grid-cols-3 gap-2 border-t border-white/10 pt-3">
                            {[
                                ["98.4%", "Accuracy"],
                                ["4.2ms", "Latency"],
                                ["24/7", "Compute"],
                            ].map(([value, label]) => (
                                <span key={label}>
                                    <strong className="block font-mono text-xs text-white">{value}</strong>
                                    <small className="text-[7px] uppercase tracking-wider text-white/35">{label}</small>
                                </span>
                            ))}
                        </div>
                    </div>

                    {/* Data research panel */}
                    <div className="absolute bottom-28 left-5 w-[min(68%,280px)] border border-white/15 bg-[#071A2F]/60 p-4 backdrop-blur-xl sm:bottom-32 sm:left-10">
                        <div className="mb-4 flex items-center justify-between">
                            <span className="font-mono text-[8px] uppercase tracking-[0.16em] text-[#D5AD57]">
                                Data Research / Live
                            </span>
                            <span className="h-2 w-2 animate-pulse rounded-full bg-emerald-400 shadow-[0_0_12px_#34D399]" />
                        </div>
                        <div className="flex h-20 items-end gap-2 border-b border-white/10">
                            {[35, 56, 42, 74, 62, 91, 78, 100].map((height, index) => (
                                <span
                                    key={`${height}-${index}`}
                                    className="flex-1 bg-gradient-to-t from-[#8B1E3F] via-blue-500 to-[#D5AD57]"
                                    style={{ height: `${height}%`, opacity: 0.45 + index * 0.06 }}
                                />
                            ))}
                        </div>
                    </div>

                    {/* Bottom institutional statement */}
                    <div className="absolute bottom-0 left-0 right-0 border-t border-white/10 bg-[#050F1F]/80 px-5 py-5 backdrop-blur-xl sm:px-10">
                        <div className="flex items-center justify-between gap-5">
                            <div>
                                <span className="block text-[8px] font-bold uppercase tracking-[0.2em] text-[#D5AD57]">
                                    Advanced Computing &amp; Research
                                </span>
                                <strong className="mt-1 block font-serif text-lg font-normal text-white/90">
                                    Future-ready by design.
                                </strong>
                            </div>
                            <a
                                href="#research"
                                className="grid h-11 w-11 shrink-0 place-items-center border border-white/20 text-white transition duration-300 hover:border-[#D5AD57] hover:bg-[#D5AD57] hover:text-[#071A2F] focus:outline-none focus:ring-2 focus:ring-[#D5AD57]"
                                aria-label="Explore technology research"
                            >
                                <Arrow diagonal />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export function SchoolOfScienceHero({
    image = SchoolofScienceImage,
    exploreHref = "#academic-programs",
    applyHref = "/apply-online",
}) {
    return (
        <section className="relative isolate min-h-[840px] overflow-hidden bg-[#061728] text-white">
            <div className="absolute inset-0 -z-30">
                <img src={image} alt="Advanced university science laboratory" className="h-full w-full object-cover object-center" />
            </div>
            <div className="absolute inset-0 -z-20 bg-[linear-gradient(90deg,rgba(6,23,40,0.98)_0%,rgba(6,23,40,0.92)_48%,rgba(6,23,40,0.58)_100%)]" />
            <div className="absolute inset-0 -z-10 opacity-[0.08] [background-image:linear-gradient(rgba(255,255,255,0.3)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.3)_1px,transparent_1px)] [background-size:64px_64px]" />

            <div className="pointer-events-none absolute right-[-90px] top-[8%] h-[520px] w-[520px] rounded-full border border-[#D5AD57]/20" />
            <div className="pointer-events-none absolute right-[3%] top-[16%] h-[390px] w-[390px] rounded-full border border-white/10" />

            <div className="mx-auto grid min-h-[840px] w-[min(1380px,calc(100%-48px))] items-center gap-14 py-28 max-sm:w-[calc(100%-28px)] lg:grid-cols-[0.9fr_1.1fr]">
                <div className="relative z-10">
                    <Breadcrumb current="Science" dark />
                    <div className="mt-10"><Eyebrow dark>School of Science</Eyebrow></div>
                    <h1 className="mt-6 max-w-[780px] font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(54px,7vw,98px)] font-normal leading-[0.98] tracking-[-0.055em]">
                        Question deeply.
                        <em className="block font-normal text-[#D5AD57]">Discover boldly.</em>
                    </h1>
                    <p className="mt-7 max-w-[690px] text-base leading-8 text-white/68">
                        Explore chemistry, physics, mathematics, forensic science and interdisciplinary research through rigorous inquiry, advanced laboratories and innovation-led learning.
                    </p>
                    <div className="mt-9 flex flex-wrap gap-4">
                        <HeroButton href={exploreHref}>Explore Programmes</HeroButton>
                        <HeroButton href={applyHref} variant="secondary" dark>Apply Now</HeroButton>
                    </div>
                    <div className="mt-12 grid max-w-[720px] gap-5 sm:grid-cols-3">
                        <Metric value="Research" label="Inquiry-led education" dark />
                        <Metric value="Labs" label="Modern scientific facilities" dark />
                        <Metric value="Future" label="Innovation pathways" dark />
                    </div>
                </div>

                <div className="relative hidden min-h-[620px] lg:block">
                    <div className="absolute inset-x-[10%] top-[8%] overflow-hidden rounded-[36px_8px_36px_8px] border border-white/20 bg-white/10 shadow-[0_40px_120px_rgba(0,0,0,0.35)] backdrop-blur-md">
                        <div className="border-b border-white/15 px-6 py-4 text-sm font-semibold text-white/70">Integrated Science Research Interface</div>
                        <div className="grid grid-cols-[1.2fr_0.8fr] gap-px bg-white/10">
                            <div className="bg-[#071A2F]/75 p-7">
                                <div className="relative h-[330px] overflow-hidden rounded-3xl border border-white/10 bg-[radial-gradient(circle_at_center,rgba(213,173,87,0.20),transparent_58%)]">
                                    <svg viewBox="0 0 520 330" className="h-full w-full" fill="none" aria-hidden="true">
                                        <path d="M65 268C147 234 128 109 215 73C292 40 344 117 339 185C334 249 414 282 466 209" stroke="#D5AD57" strokeWidth="2" />
                                        <path d="M65 68C147 102 128 227 215 263C292 296 344 219 339 151C334 87 414 54 466 127" stroke="#8B1E3F" strokeWidth="2" />
                                        {[95, 145, 195, 245, 295, 345, 395, 445].map((x, i) => <circle key={x} cx={x} cy={i % 2 ? 118 : 214} r="9" fill="#071A2F" stroke="#D5AD57" strokeWidth="2" />)}
                                    </svg>
                                </div>
                                <div className="mt-5 grid grid-cols-3 gap-3">
                                    {["Molecular", "Quantum", "Analytical"].map((item) => <div key={item} className="border border-white/10 bg-white/[0.04] p-3 text-sm text-white/65">{item}</div>)}
                                </div>
                            </div>
                            <div className="bg-[#0C2744]/80 p-6">
                                {[
                                    ["Chemistry", "Molecular systems"],
                                    ["Physics", "Matter and energy"],
                                    ["Mathematics", "Patterns and models"],
                                    ["Forensics", "Evidence and analysis"],
                                ].map(([title, text], i) => (
                                    <div key={title} className="border-b border-white/12 py-5">
                                        <span className="text-sm font-bold text-[#D5AD57]">0{i + 1}</span>
                                        <strong className="mt-2 block font-['Libre_Caslon_Display',Georgia,serif] text-xl font-normal">{title}</strong>
                                        <span className="mt-1 block text-sm text-white/45">{text}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="absolute bottom-[6%] left-[2%] w-52 border border-white/20 bg-[#071A2F]/80 p-5 backdrop-blur-xl">
                        <span className="text-sm font-bold uppercase tracking-[0.12em] text-[#D5AD57]">Research Signal</span>
                        <div className="mt-4 flex h-20 items-end gap-2">{[38, 62, 48, 76, 58, 88, 70].map((h, i) => <span key={i} className="w-full bg-[#D5AD57]/80" style={{ height: `${h}%` }} />)}</div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export function SchoolOfArtsHumanitiesHero({
    image = SchoolofArtsandHumanitiesImage,
    exploreHref = "#academic-programs",
    applyHref = "/apply-online",
}) {
    return (
        <section className="relative overflow-hidden bg-[#F7F2E8] text-[#132337]">
            <div className="mx-auto min-h-[780px] w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)]">
                <div className="grid min-h-[780px] lg:grid-cols-[0.88fr_1.12fr]">
                    <div className="relative z-10 flex flex-col justify-center py-24 lg:pr-14">
                        <div className="flex items-center gap-3 text-sm font-extrabold uppercase tracking-[0.16em] text-[#8B1E3F]"><span className="h-px w-10 bg-current" />School of Arts & Humanities</div>
                        <h1 className="mt-6 max-w-[760px] font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(54px,6.3vw,96px)] font-normal leading-[1] tracking-[-0.05em] text-[#071A2F]">
                            Ideas shape culture.
                            <em className="block font-normal text-[#8B1E3F]">Culture shapes the world.</em>
                        </h1>
                        <p className="mt-7 max-w-[640px] text-base leading-8 text-[#586575]">
                            Study language, society, history, philosophy, public life and human expression through critical inquiry and meaningful engagement.
                        </p>
                        <div className="mt-9 flex flex-wrap gap-4">
                            <a href="#academic-programs" className="inline-flex min-h-[54px] items-center gap-5 bg-[#071A2F] px-7 text-sm font-extrabold uppercase tracking-[0.08em] text-white transition hover:bg-[#8B1E3F]">Explore Programmes <span>↗</span></a>
                            <a href="/apply-online" className="inline-flex min-h-[54px] items-center gap-5 border-2 border-[#071A2F] px-7 text-sm font-extrabold uppercase tracking-[0.08em] text-[#071A2F] transition hover:bg-[#071A2F] hover:text-white">Apply Now <span>→</span></a>
                        </div>
                        <blockquote className="mt-12 max-w-[650px] border-l-2 border-[#D5AD57] pl-6 font-['Libre_Caslon_Display',Georgia,serif] text-2xl italic leading-9 text-[#071A2F]">
                            “Where scholarship meets imagination, new ways of understanding begin.”
                        </blockquote>
                    </div>

                    <div className="relative min-h-[540px] lg:min-h-full">
                        <div className="absolute inset-0 lg:left-8">
                            <img src={image} alt="Students engaged in arts and humanities learning" className="h-full w-full object-cover" />
                            <div className="absolute inset-0 bg-[linear-gradient(180deg,transparent_40%,rgba(7,26,47,0.72)_100%)]" />
                        </div>
                        <div className="absolute left-0 top-16 hidden h-[72%] w-24 bg-[#8B1E3F] lg:block" />
                        <div className="absolute bottom-8 left-8 right-8 grid border border-white/25 bg-[#071A2F]/78 text-white backdrop-blur-xl sm:grid-cols-3">
                            {["Language", "Culture", "Society"].map((item, index) => (
                                <div key={item} className="border-b border-white/15 p-5 last:border-b-0 sm:border-b-0 sm:border-r sm:last:border-r-0">
                                    <span className="text-sm font-bold text-[#D5AD57]">0{index + 1}</span>
                                    <strong className="mt-2 block font-['Libre_Caslon_Display',Georgia,serif] text-2xl font-normal">{item}</strong>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export function SchoolOfLawHero({
    image = SchoolofLawImage,
    exploreHref = "#academic-programs",
    applyHref = "/apply-online",
}) {
    return (
        <section className="relative isolate overflow-hidden bg-[#071A2F] text-white">
            <div className="absolute inset-0 -z-20"><img src={image} alt="University law students in a moot court setting" className="h-full w-full object-cover" /></div>
            <div className="absolute inset-0 -z-10 bg-[linear-gradient(90deg,rgba(7,26,47,0.98)_0%,rgba(7,26,47,0.94)_45%,rgba(7,26,47,0.58)_100%)]" />
            <div className="absolute inset-y-0 right-[9%] hidden w-px bg-[#D5AD57]/25 lg:block" />
            <div className="absolute right-[9%] top-[14%] hidden h-px w-[34%] bg-[#D5AD57]/25 lg:block" />

            <div className="mx-auto grid min-h-[790px] w-[min(1380px,calc(100%-48px))] items-center gap-12 py-28 max-sm:w-[calc(100%-28px)] lg:grid-cols-[1fr_0.72fr]">
                <div>
                    <div className="flex items-center gap-3 text-sm font-extrabold uppercase tracking-[0.16em] text-[#D5AD57]"><span className="h-px w-10 bg-current" />School of Law</div>
                    <h1 className="mt-6 max-w-[880px] font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(58px,7vw,108px)] font-normal leading-[0.96] tracking-[-0.055em]">
                        Study justice.
                        <em className="block font-normal text-[#D5AD57]">Lead with principle.</em>
                    </h1>
                    <p className="mt-7 max-w-[680px] text-base leading-8 text-white/70">
                        Develop rigorous legal reasoning, advocacy, ethical judgement and public leadership through a professionally grounded legal education.
                    </p>
                    <div className="mt-9 flex flex-wrap gap-4">
                        <a href="#academic-programs" className="inline-flex min-h-[54px] items-center gap-5 rounded-full bg-[#D5AD57] px-7 text-sm font-extrabold uppercase tracking-[0.08em] text-[#071A2F] transition hover:bg-white">View Law Programmes <span>↗</span></a>
                        <a href="/apply-online" className="inline-flex min-h-[54px] items-center gap-5 rounded-full border border-white/25 px-7 text-sm font-extrabold uppercase tracking-[0.08em] text-white transition hover:border-[#D5AD57] hover:text-[#D5AD57]">Apply Now <span>→</span></a>
                    </div>
                </div>

                <aside className="relative border-l border-white/15 pl-8 lg:pl-12">
                    <div className="absolute -left-5 top-0 grid h-10 w-10 place-items-center rounded-full border border-[#D5AD57]/50 bg-[#071A2F] text-[#D5AD57]">§</div>
                    <span className="text-sm font-extrabold uppercase tracking-[0.14em] text-[#D5AD57]">Legal formation</span>
                    <div className="mt-6 border-t border-white/15">
                        {["Moot Court Advocacy", "Constitutional Reasoning", "Corporate & Civil Law", "Research & Legal Writing"].map((item, index) => (
                            <div key={item} className="grid min-h-[86px] grid-cols-[42px_1fr_auto] items-center gap-4 border-b border-white/15">
                                <span className="text-sm font-bold text-[#D5AD57]">0{index + 1}</span>
                                <strong className="font-['Libre_Caslon_Display',Georgia,serif] text-2xl font-normal">{item}</strong>
                                <span className="text-[#D5AD57]">→</span>
                            </div>
                        ))}
                    </div>
                    <p className="mt-8 border-l-2 border-[#8B1E3F] pl-5 text-base leading-8 text-white/65">Built for future advocates, legal professionals, researchers and public leaders.</p>
                </aside>
            </div>
        </section>
    );
}

export function SchoolOfPharmacyHero({
    image = SchoolofPharmacyImage,
    exploreHref = "#academic-programs",
    applyHref = "/apply-online",
}) {
    return (
        <section className="relative overflow-hidden bg-[#F7F2E8] text-[#132337]">
            <div className="mx-auto grid min-h-[840px] w-[min(1380px,calc(100%-48px))] items-center gap-12 py-24 max-sm:w-[calc(100%-28px)] lg:grid-cols-[0.86fr_1.14fr]">
                <div className="relative z-10">
                    <Breadcrumb current="Pharmacy" />
                    <div className="mt-10"><Eyebrow>School of Pharmacy</Eyebrow></div>
                    <h1 className="mt-6 max-w-[780px] font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(52px,6.4vw,90px)] font-normal leading-[1] tracking-[-0.05em] text-[#071A2F]">
                        Advancing medicine through
                        <em className="block font-normal text-[#8B1E3F]">precision and discovery.</em>
                    </h1>
                    <p className="mt-7 max-w-[650px] text-base leading-8 text-[#586575]">
                        Study pharmaceutical sciences through drug development, medicinal chemistry, clinical understanding and research-led practice designed for modern healthcare.
                    </p>
                    <div className="mt-9 flex flex-wrap gap-4">
                        <HeroButton href={exploreHref}>Explore Programmes</HeroButton>
                        <HeroButton href={applyHref} variant="secondary">Apply Now</HeroButton>
                    </div>
                    <div className="mt-12 grid max-w-[690px] gap-4 sm:grid-cols-3">
                        {[
                            ["Formulation", "Drug design and delivery"],
                            ["Research", "Pharmaceutical innovation"],
                            ["Clinical", "Patient-centred science"],
                        ].map(([title, text]) => <div key={title} className="border-t-2 border-[#8B1E3F] bg-white/65 p-5"><strong className="font-['Libre_Caslon_Display',Georgia,serif] text-2xl font-normal text-[#071A2F]">{title}</strong><span className="mt-2 block text-sm leading-6 text-[#65717D]">{text}</span></div>)}
                    </div>
                </div>

                <div className="relative min-h-[650px]">
                    <div className="absolute inset-y-[6%] right-0 w-[86%] overflow-hidden rounded-[70px_12px_70px_12px] shadow-[0_40px_100px_rgba(7,26,47,0.18)]">
                        <img src={image} alt="Pharmaceutical research and laboratory practice" className="h-full w-full object-cover" />
                        <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(7,26,47,0.05),rgba(7,26,47,0.72))]" />
                    </div>

                    <div className="absolute left-0 top-[12%] w-64 border border-[#071A2F]/10 bg-white p-6 shadow-[0_24px_70px_rgba(7,26,47,0.15)]">
                        <div className="flex items-center justify-between"><span className="text-sm font-bold uppercase tracking-[0.12em] text-[#8B1E3F]">Molecule Profile</span><span className="h-2 w-2 rounded-full bg-[#8B1E3F]" /></div>
                        <svg viewBox="0 0 240 150" className="mt-5 w-full" fill="none" aria-hidden="true">
                            <path d="M40 74l40-34 46 19 38-30 42 39-34 48-53-9-39 26-40-59Z" stroke="#071A2F" strokeWidth="2" />
                            {[40, 80, 126, 164, 206, 172, 119, 80].map((x, i) => <circle key={i} cx={x} cy={[74, 40, 59, 29, 68, 116, 107, 133][i]} r="8" fill="#F7F2E8" stroke={i % 2 ? "#D5AD57" : "#8B1E3F"} strokeWidth="3" />)}
                        </svg>
                    </div>

                    <div className="absolute bottom-[9%] left-[8%] flex w-[72%] items-center gap-5 rounded-full border border-white/40 bg-[#071A2F]/85 p-4 pr-6 text-white backdrop-blur-xl">
                        <div className="relative h-16 w-28 overflow-hidden rounded-full bg-white/10">
                            <div className="absolute left-0 top-0 h-full w-1/2 bg-[#D5AD57]" />
                            <div className="absolute right-0 top-0 h-full w-1/2 bg-white" />
                        </div>
                        <div><strong className="font-['Libre_Caslon_Display',Georgia,serif] text-xl font-normal">Drug Development Pathway</strong><span className="mt-1 block text-sm text-white/55">Discovery → Formulation → Quality → Care</span></div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export function SchoolOfDesignHero({
    image = SchoolofDesignImage,
    exploreHref = "#academic-programs",
    applyHref = "/apply-online",
}) {
    return (
        <section className="relative overflow-hidden bg-white text-[#132337]">
            <div className="absolute inset-y-0 right-0 hidden w-[46%] bg-[#071A2F] lg:block" />
            <div className="mx-auto grid min-h-[840px] w-[min(1380px,calc(100%-48px))] items-center gap-14 py-24 max-sm:w-[calc(100%-28px)] lg:grid-cols-[0.84fr_1.16fr]">
                <div className="relative z-10">
                    <Breadcrumb current="Design" />
                    <div className="mt-10"><Eyebrow>School of Design</Eyebrow></div>
                    <h1 className="mt-6 max-w-[760px] font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(54px,7vw,96px)] font-normal leading-[0.96] tracking-[-0.055em] text-[#071A2F]">
                        Imagine.
                        <span className="text-[#8B1E3F]"> Design.</span>
                        <em className="block font-normal text-[#A77B2D]">Transform.</em>
                    </h1>
                    <p className="mt-7 max-w-[620px] text-base leading-8 text-[#586575]">
                        Explore fashion, interiors, products and digital experiences through studio practice, visual experimentation, material thinking and human-centred innovation.
                    </p>
                    <div className="mt-9 flex flex-wrap gap-4"><HeroButton href={exploreHref}>View Design Programmes</HeroButton><HeroButton href={applyHref} variant="secondary">Apply Now</HeroButton></div>
                    <div className="mt-12 flex flex-wrap gap-3">
                        {["Fashion", "Interior", "Product", "UI/UX", "Visual Communication"].map((item) => <span key={item} className="border border-[#071A2F]/15 bg-[#F7F2E8] px-4 py-2 text-sm font-semibold text-[#071A2F]">{item}</span>)}
                    </div>
                </div>

                <div className="relative min-h-[650px]">
                    <div className="absolute left-[4%] top-[6%] h-[46%] w-[48%] overflow-hidden rounded-[90px_10px_10px_10px] border-[10px] border-white shadow-[0_30px_80px_rgba(0,0,0,0.24)]">
                        <img src={image} alt="Contemporary design studio" className="h-full w-full object-cover" />
                    </div>
                    <div className="absolute right-[2%] top-[10%] h-[34%] w-[40%] bg-[#D5AD57] p-7 text-[#071A2F]">
                        <span className="text-sm font-bold uppercase tracking-[0.12em]">Colour Study</span>
                        <div className="mt-6 grid grid-cols-4 gap-3">{["#071A2F", "#8B1E3F", "#D5AD57", "#F7F2E8", "#0C2744", "#A77B2D", "#FFFFFF", "#132337"].map((c) => <span key={c} className="aspect-square border border-[#071A2F]/10" style={{ backgroundColor: c }} />)}</div>
                    </div>
                    <div className="absolute bottom-[7%] left-[16%] h-[55%] w-[52%] bg-white p-7 shadow-[0_30px_90px_rgba(0,0,0,0.24)]">
                        <span className="text-sm font-bold uppercase tracking-[0.12em] text-[#8B1E3F]">Creative Workflow</span>
                        <div className="mt-6 space-y-5">{[["01", "Research"], ["02", "Ideate"], ["03", "Prototype"], ["04", "Refine"]].map(([n, t]) => <div key={n} className="flex items-center gap-4 border-b border-[#071A2F]/10 pb-4"><span className="text-sm font-bold text-[#A77B2D]">{n}</span><strong className="font-['Libre_Caslon_Display',Georgia,serif] text-2xl font-normal text-[#071A2F]">{t}</strong></div>)}</div>
                    </div>
                    <div className="absolute bottom-[5%] right-[0%] h-[34%] w-[30%] rounded-[10px_70px_10px_10px] bg-[#8B1E3F] p-6 text-white">
                        <svg viewBox="0 0 180 180" className="h-full w-full" fill="none" aria-hidden="true"><path d="M25 145 90 25l65 120H25Z" stroke="#F7F2E8" /><circle cx="90" cy="90" r="45" stroke="#D5AD57" /><path d="M45 90h90M90 45v90" stroke="#F7F2E8" strokeOpacity=".5" /></svg>
                    </div>
                </div>
            </div>
        </section>
    );
}

export function SchoolOfEducationHero({
    image = SchoolofEducationImage,
    exploreHref = "#academic-programs",
    applyHref = "/apply-online",
}) {
    return (
        <section className="relative overflow-hidden bg-white text-[#132337]">
            <div className="absolute inset-y-0 left-0 w-full bg-[linear-gradient(90deg,#071A2F_0%,#071A2F_38%,#FFFFFF_38%,#FFFFFF_100%)] max-lg:bg-white" />
            <div className="relative mx-auto grid min-h-[780px] w-[min(1380px,calc(100%-48px))] items-center gap-12 py-24 max-sm:w-[calc(100%-28px)] lg:grid-cols-[0.7fr_1.3fr]">
                <aside className="relative hidden min-h-[580px] text-white lg:block">
                    <div className="absolute left-0 top-0 h-full w-[88%] overflow-hidden rounded-[8px_70px_8px_8px]">
                        <img src={image} alt="Teacher education students in a modern classroom" className="h-full w-full object-cover opacity-75" />
                        <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(7,26,47,.08),rgba(7,26,47,.9))]" />
                    </div>
                    <div className="absolute bottom-8 left-8 max-w-[300px] border-l-2 border-[#D5AD57] pl-5">
                        <span className="text-sm font-bold uppercase tracking-[0.12em] text-[#D5AD57]">The educator’s role</span>
                        <p className="mt-3 font-['Libre_Caslon_Display',Georgia,serif] text-3xl leading-[1.25]">Inspire learning. Strengthen communities.</p>
                    </div>
                </aside>

                <div className="relative z-10 lg:pl-8">
                    <div className="flex items-center gap-3 text-sm font-extrabold uppercase tracking-[0.16em] text-[#8B1E3F]"><span className="h-px w-10 bg-current" />School of Education</div>
                    <h1 className="mt-6 max-w-[850px] font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(54px,6.5vw,98px)] font-normal leading-[1] tracking-[-0.05em] text-[#071A2F]">
                        Educators who shape
                        <em className="block font-normal text-[#8B1E3F]">future generations.</em>
                    </h1>
                    <p className="mt-7 max-w-[700px] text-base leading-8 text-[#586575]">Prepare for meaningful academic leadership through pedagogy, reflective practice, educational research and learner-centred teaching.</p>
                    <div className="mt-9 flex flex-wrap gap-4">
                        <a href="#academic-programs" className="inline-flex min-h-[54px] items-center gap-5 rounded-full bg-[#071A2F] px-7 text-sm font-extrabold uppercase tracking-[0.08em] text-white transition hover:bg-[#8B1E3F]">Explore Programmes <span>↗</span></a>
                        <a href="/apply-online" className="inline-flex min-h-[54px] items-center gap-5 rounded-full border border-[#071A2F]/20 px-7 text-sm font-extrabold uppercase tracking-[0.08em] text-[#071A2F] transition hover:border-[#8B1E3F] hover:text-[#8B1E3F]">Apply Now <span>→</span></a>
                    </div>
                    <div className="mt-12 grid border-y border-[#071A2F]/12 sm:grid-cols-3">
                        {["Pedagogy", "Research", "Leadership"].map((item, index) => (
                            <div key={item} className="min-h-[116px] border-b border-[#071A2F]/12 p-5 last:border-b-0 sm:border-b-0 sm:border-r sm:last:border-r-0">
                                <span className="text-sm font-bold text-[#8B1E3F]">0{index + 1}</span>
                                <strong className="mt-3 block font-['Libre_Caslon_Display',Georgia,serif] text-2xl font-normal text-[#071A2F]">{item}</strong>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}

export function SchoolOfJournalismMassCommunicationHero({
    image = SchoolofJournalismandMassCommunicationImage,
    exploreHref = "#academic-programs",
    applyHref = "/apply-online",
}) {
    return (
        <section className="relative min-h-[850px] overflow-hidden bg-[#F7F2E8] text-[#132337]">
            <div className="absolute inset-x-0 top-0 h-12 bg-[#8B1E3F] text-white">
                <div className="mx-auto flex h-full w-[min(1380px,calc(100%-48px))] items-center justify-between text-sm font-semibold max-sm:w-[calc(100%-28px)]"><span>LIVE • NEWSROOM • DIGITAL • BROADCAST</span><span className="hidden sm:block">School of Journalism & Mass Communication</span></div>
            </div>
            <div className="mx-auto grid min-h-[850px] w-[min(1380px,calc(100%-48px))] items-center gap-14 pb-20 pt-28 max-sm:w-[calc(100%-28px)] lg:grid-cols-[0.88fr_1.12fr]">
                <div>
                    <Breadcrumb current="Journalism & Mass Communication" />
                    <div className="mt-10"><Eyebrow>School of Journalism & Mass Communication</Eyebrow></div>
                    <h1 className="mt-6 max-w-[790px] font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(52px,6.5vw,92px)] font-normal leading-[0.98] tracking-[-0.055em] text-[#071A2F]">
                        Report truth.
                        <em className="block font-normal text-[#8B1E3F]">Shape public conversation.</em>
                    </h1>
                    <p className="mt-7 max-w-[670px] text-base leading-8 text-[#586575]">Learn reporting, broadcasting, digital storytelling, media production and communication strategy through newsroom practice and ethical inquiry.</p>
                    <div className="mt-9 flex flex-wrap gap-4"><HeroButton href={exploreHref}>Explore Programmes</HeroButton><HeroButton href={applyHref} variant="secondary">Apply Now</HeroButton></div>
                    <div className="mt-12 grid gap-4 sm:grid-cols-3">{[["Newsroom", "Reporting and editing"], ["Studio", "Audio-visual production"], ["Digital", "Multiplatform storytelling"]].map(([a, b]) => <Metric key={a} value={a} label={b} />)}</div>
                </div>

                <div className="relative min-h-[630px]">
                    <div className="absolute inset-x-[4%] top-[4%] h-[72%] overflow-hidden border-[12px] border-[#071A2F] bg-[#071A2F] shadow-[0_35px_90px_rgba(7,26,47,0.24)]">
                        <img src={image} alt="Professional newsroom and broadcast studio" className="h-full w-full object-cover" />
                        <div className="absolute inset-0 bg-[linear-gradient(180deg,transparent,rgba(7,26,47,0.75))]" />
                        <div className="absolute bottom-0 left-0 right-0 border-t border-white/20 bg-[#071A2F]/85 px-6 py-4 text-white backdrop-blur-md"><div className="flex items-center gap-4"><span className="bg-[#8B1E3F] px-3 py-1 text-sm font-bold">LIVE</span><strong className="font-['Libre_Caslon_Display',Georgia,serif] text-2xl font-normal">Stories that inform society</strong></div></div>
                    </div>
                    <div className="absolute bottom-[3%] left-0 w-[46%] bg-white p-6 shadow-[0_24px_70px_rgba(7,26,47,0.18)]">
                        <span className="text-sm font-bold uppercase tracking-[0.12em] text-[#8B1E3F]">Editorial Desk</span>
                        <div className="mt-5 space-y-4">{["Investigate", "Verify", "Report", "Engage"].map((item, i) => <div key={item} className="flex items-center justify-between border-b border-[#071A2F]/10 pb-3"><span className="text-sm text-[#A77B2D]">0{i + 1}</span><strong className="font-['Libre_Caslon_Display',Georgia,serif] text-xl font-normal text-[#071A2F]">{item}</strong></div>)}</div>
                    </div>
                    <div className="absolute bottom-[7%] right-0 w-[42%] bg-[#D5AD57] p-6 text-[#071A2F]"><span className="text-sm font-bold uppercase tracking-[0.12em]">Media Channels</span><div className="mt-5 grid grid-cols-2 gap-3">{["TV", "Radio", "Print", "Digital"].map((item) => <div key={item} className="border border-[#071A2F]/20 bg-white/35 p-3 text-center text-base font-bold">{item}</div>)}</div></div>
                </div>
            </div>
        </section>
    );
}

export function SchoolOfHotelManagementHero({
    image = SchoolofHotelManagementImage,
    exploreHref = "#academic-programs",
    applyHref = "/apply-online",
}) {
    const highlights = [
        ["01", "Industry-focused learning", "Hospitality concepts aligned with professional operations."],
        ["02", "Practical training", "Hands-on exposure across service, culinary and front-office environments."],
        ["03", "Global careers", "Preparation for hotels, resorts, tourism, aviation and events."],
        ["04", "Internship support", "Structured guidance for real-world industry experience."],
    ];

    return (
        <section aria-labelledby="hotel-management-hero-heading" className="relative isolate overflow-hidden bg-[radial-gradient(circle_at_9%_15%,rgba(213,173,87,.14),transparent_23%),linear-gradient(118deg,#fffdf8_0%,#F7F2E8_54%,#eee6d8_100%)] py-20 text-[#132337] sm:py-24 lg:min-h-[92vh] lg:py-[124px]">
            <div className="absolute inset-y-0 left-0 w-[7px] bg-gradient-to-b from-[#D5AD57] to-[#8B1E3F]" />
            <div className="pointer-events-none absolute inset-0 -z-10 opacity-[0.23] [background-image:linear-gradient(rgba(7,26,47,.04)_1px,transparent_1px),linear-gradient(90deg,rgba(7,26,47,.04)_1px,transparent_1px)] [background-size:72px_72px] [mask-image:linear-gradient(90deg,#000_0%,transparent_61%)]" />

            <div className="mx-auto w-[min(1440px,calc(100%-48px))] max-sm:w-[calc(100%-28px)]">
                <div className="grid items-center gap-14 lg:grid-cols-[0.84fr_1.16fr]">
                    <div className="max-w-[720px]">
                        <Eyebrow>School of Hotel Management</Eyebrow>
                        <h1 id="hotel-management-hero-heading" className="mt-6 font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(50px,6.2vw,96px)] font-semibold leading-[0.98] tracking-[-0.055em] text-[#071A2F]">
                            Shape the Future of <em className="block font-medium text-[#8B1E3F]">Global Hospitality</em>
                        </h1>
                        <p className="mt-7 max-w-[650px] text-base leading-8 text-[#132337]/70 sm:text-lg">
                            Develop the operational expertise, service intelligence and leadership perspective required for luxury hospitality, culinary arts, tourism, event management and exceptional guest experience.
                        </p>
                        <div className="mt-9 flex flex-col gap-4 sm:flex-row">
                            <a href={exploreHref} className="inline-flex min-h-[55px] items-center justify-center gap-4 rounded px-6 text-sm font-extrabold text-white shadow-[0_15px_34px_rgba(7,26,47,.2)] transition hover:-translate-y-1 hover:bg-[#0C2744] hover:shadow-[0_21px_44px_rgba(7,26,47,.28)] bg-[#071A2F]">Explore Programmes <Arrow diagonal /></a>
                            <a href={applyHref} className="inline-flex min-h-[55px] items-center justify-center gap-4 rounded border border-[#071A2F]/25 bg-white/50 px-6 text-sm font-extrabold text-[#071A2F] transition hover:-translate-y-1 hover:border-[#8B1E3F] hover:bg-[#8B1E3F] hover:text-white">Apply Now <Arrow /></a>
                        </div>
                        <div className="mt-10 flex items-center gap-4">
                            <div className="grid h-12 w-12 shrink-0 place-items-center border border-[#A77B2D]/30 bg-white/60 text-xl text-[#A77B2D]">✦</div>
                            <div><span className="block text-sm uppercase tracking-[0.08em] text-[#132337]/55">University-led hospitality education</span><strong className="mt-1 block text-base text-[#071A2F]">Academic excellence with industry immersion</strong></div>
                        </div>
                    </div>

                    <div className="relative min-h-[620px] lg:min-h-[700px]">
                        <div className="absolute left-3 top-0 h-[54%] w-[54%] border border-[#A77B2D]/50" />
                        <div className="absolute bottom-0 right-0 h-[45%] w-[38%] bg-gradient-to-br from-[#D5AD57] to-[#A77B2D]" />
                        <div className="group absolute inset-x-0 bottom-7 top-6 right-7 overflow-hidden bg-[#071A2F] shadow-[0_38px_90px_rgba(7,26,47,.24)]">
                            <img src={image} alt="Premium hotel training environment representing professional hospitality education" className="h-full w-full scale-[1.015] object-cover transition duration-1000 group-hover:scale-[1.055]" />
                            <div className="absolute inset-0 bg-[linear-gradient(90deg,rgba(7,26,47,.18),transparent_46%),linear-gradient(180deg,transparent_48%,rgba(7,26,47,.72)_100%)]" />
                            <div className="absolute right-5 top-[30%] [writing-mode:vertical-rl] text-sm font-bold uppercase tracking-[0.17em] text-white/80">Hospitality · Leadership · Excellence</div>
                            <article className="absolute bottom-0 left-0 w-[min(88%,570px)] border-l-4 border-[#D5AD57] bg-[#071A2F]/75 p-6 text-white shadow-[0_22px_54px_rgba(0,0,0,.2)] backdrop-blur-xl sm:p-8">
                                <span className="text-sm font-extrabold uppercase tracking-[0.16em] text-[#ECD48F]">Academic Experience</span>
                                <h2 className="mt-3 font-['Libre_Caslon_Display',Georgia,serif] text-2xl font-normal leading-tight sm:text-3xl">Learn through real-world hospitality environments</h2>
                                <div className="mt-5 flex flex-wrap gap-x-6 gap-y-3 text-sm text-white/80"><span>Hotel Operations</span><span>Culinary & Service</span><span>Tourism & Events</span></div>
                            </article>
                            <article className="absolute right-0 top-[11%] flex items-center gap-3 border border-white/25 bg-white/90 p-4 text-[#071A2F] shadow-xl backdrop-blur-xl">
                                <div className="grid h-10 w-10 place-items-center border border-[#A77B2D]/30 text-[#A77B2D]">✦</div>
                                <div><span className="block text-sm uppercase tracking-[0.08em] text-[#132337]/55">Professional Standard</span><strong className="mt-1 block text-sm">Guest-first leadership</strong></div>
                            </article>
                        </div>
                    </div>
                </div>

                <div className="mt-12 grid border-y border-[#071A2F]/15 sm:grid-cols-2 xl:grid-cols-4">
                    {highlights.map(([number, title, text]) => (
                        <article key={number} className="flex min-h-[150px] gap-4 border-b border-[#071A2F]/15 bg-white/25 p-6 transition hover:-translate-y-1 hover:bg-white/65 sm:border-r xl:border-b-0 xl:last:border-r-0">
                            <span className="font-['Libre_Caslon_Display',Georgia,serif] text-base font-bold text-[#A77B2D]">{number}</span>
                            <div><h3 className="text-base font-extrabold text-[#071A2F]">{title}</h3><p className="mt-2 text-sm leading-6 text-[#132337]/65">{text}</p></div>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
}

export function SchoolOfMediaEntertainmentHero({
    image = SchoolofMediaandEntertainmentImage,
    exploreHref = "#academic-programs",
    applyHref = "/apply-online",
}) {
    return (
        <section className="relative isolate min-h-[860px] overflow-hidden bg-[#050D18] text-white">
            <div className="absolute inset-0 -z-20"><img src={image} alt="Film and media production environment" className="h-full w-full object-cover" /></div>
            <div className="absolute inset-0 -z-10 bg-[linear-gradient(90deg,rgba(5,13,24,0.98)_0%,rgba(5,13,24,0.88)_48%,rgba(5,13,24,0.56)_100%)]" />
            <div className="absolute inset-x-0 top-0 h-16 border-b border-white/15 bg-black/30 backdrop-blur-md"><div className="mx-auto flex h-full w-[min(1380px,calc(100%-48px))] items-center gap-8 text-sm font-semibold text-white/70 max-sm:w-[calc(100%-28px)]"><span className="text-[#D5AD57]">REC ●</span><span>FILM</span><span>VFX</span><span>ANIMATION</span><span className="hidden sm:inline">MUSIC</span><span className="hidden md:inline">OTT</span></div></div>
            <div className="mx-auto grid min-h-[860px] w-[min(1380px,calc(100%-48px))] items-center gap-14 pb-24 pt-32 max-sm:w-[calc(100%-28px)] lg:grid-cols-[0.88fr_1.12fr]">
                <div className="relative z-10">
                    <Breadcrumb current="Media & Entertainment" dark />
                    <div className="mt-10"><Eyebrow dark>School of Media & Entertainment</Eyebrow></div>
                    <h1 className="mt-6 max-w-[800px] font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(54px,7vw,100px)] font-normal leading-[0.96] tracking-[-0.055em]">Create stories that <em className="block font-normal text-[#D5AD57]">move culture.</em></h1>
                    <p className="mt-7 max-w-[660px] text-base leading-8 text-white/65">Develop cinematic vision, production craft and digital creativity across film, advertising, public relations, animation, VFX and event experiences.</p>
                    <div className="mt-9 flex flex-wrap gap-4"><HeroButton href={exploreHref}>Explore Programmes</HeroButton><HeroButton href={applyHref} variant="secondary" dark>Apply Now</HeroButton></div>
                </div>

                <div className="relative hidden min-h-[620px] lg:block">
                    <div className="absolute left-[8%] top-[7%] h-[68%] w-[82%] border-[14px] border-black bg-black shadow-[0_40px_120px_rgba(0,0,0,0.5)]">
                        <div className="absolute -top-8 left-0 flex gap-2">{Array.from({ length: 8 }).map((_, i) => <span key={i} className="h-5 w-10 bg-white/25" />)}</div>
                        <img src={image} alt="Cinema production scene" className="h-full w-full object-cover" />
                        <div className="absolute inset-0 ring-1 ring-inset ring-white/10" />
                    </div>
                    <div className="absolute bottom-[5%] left-0 w-[58%] bg-[#8B1E3F] p-6 shadow-[0_25px_80px_rgba(0,0,0,0.35)]"><span className="text-sm font-bold uppercase tracking-[0.12em] text-white/65">Production Timeline</span><div className="mt-5 flex items-center gap-2">{["Script", "Shoot", "Edit", "Release"].map((item, i) => <React.Fragment key={item}><div className="text-center"><span className="mx-auto grid h-10 w-10 place-items-center rounded-full border border-white/40 text-sm">0{i + 1}</span><span className="mt-2 block text-sm">{item}</span></div>{i < 3 && <span className="h-px flex-1 bg-white/25" />}</React.Fragment>)}</div></div>
                    <div className="absolute bottom-[7%] right-0 w-[34%] border border-white/20 bg-[#071A2F]/85 p-6 backdrop-blur-xl"><span className="text-sm font-bold uppercase tracking-[0.12em] text-[#D5AD57]">Creative Suite</span><div className="mt-5 grid grid-cols-2 gap-3">{["4K", "VFX", "3D", "Audio"].map((item) => <div key={item} className="border border-white/15 p-3 text-center font-bold text-white/75">{item}</div>)}</div></div>
                </div>
            </div>
        </section>
    );
}

export function SchoolOfLibraryInformationScienceHero({
    image = SchoolofLibraryandInformationScienceImage,
    exploreHref = "#academic-programs",
    applyHref = "/apply-online",
}) {
    return (
        <section className="relative overflow-hidden bg-[#F7F2E8] text-[#132337]">
            <div className="absolute inset-0 opacity-[0.035] [background-image:linear-gradient(rgba(7,26,47,.45)_1px,transparent_1px)] [background-size:100%_42px]" />
            <div className="relative mx-auto grid min-h-[780px] w-[min(1380px,calc(100%-48px))] items-center gap-14 py-24 max-sm:w-[calc(100%-28px)] lg:grid-cols-[1fr_0.9fr]">
                <div>
                    <div className="flex items-center gap-3 text-sm font-extrabold uppercase tracking-[0.16em] text-[#8B1E3F]"><span className="h-px w-10 bg-current" />School of Library & Information Science</div>
                    <h1 className="mt-6 max-w-[880px] font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(52px,6.4vw,96px)] font-normal leading-[1] tracking-[-0.05em] text-[#071A2F]">
                        Organising knowledge for
                        <em className="block font-normal text-[#8B1E3F]">a connected world.</em>
                    </h1>
                    <p className="mt-7 max-w-[690px] text-base leading-8 text-[#586575]">Prepare for modern knowledge services through information organisation, digital libraries, research support and emerging information technologies.</p>
                    <div className="mt-9 flex flex-wrap gap-4">
                        <a href="#academic-programs" className="inline-flex min-h-[54px] items-center gap-5 bg-[#071A2F] px-7 text-sm font-extrabold uppercase tracking-[0.08em] text-white transition hover:bg-[#8B1E3F]">Explore Programmes <span>↗</span></a>
                        <a href="/apply-online" className="inline-flex min-h-[54px] items-center gap-5 border-2 border-[#071A2F] px-7 text-sm font-extrabold uppercase tracking-[0.08em] text-[#071A2F] transition hover:bg-[#071A2F] hover:text-white">Apply Now <span>→</span></a>
                    </div>
                    <div className="mt-12 grid max-w-[760px] border-t-2 border-[#071A2F] sm:grid-cols-3">
                        {["Digital Libraries", "Knowledge Systems", "Research Support"].map((item, index) => (
                            <div key={item} className="min-h-[120px] border-b border-[#071A2F]/15 p-5 sm:border-b-0 sm:border-r sm:last:border-r-0">
                                <span className="text-sm font-bold text-[#8B1E3F]">0{index + 1}</span>
                                <strong className="mt-3 block font-['Libre_Caslon_Display',Georgia,serif] text-2xl font-normal text-[#071A2F]">{item}</strong>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="relative min-h-[570px]">
                    <div className="absolute inset-0 overflow-hidden border-2 border-[#071A2F] bg-white p-4">
                        <img src={image} alt="Students in a modern academic library" className="h-full w-full object-cover" />
                    </div>
                    <div className="absolute -left-8 top-12 hidden w-[220px] bg-[#8B1E3F] p-6 text-white shadow-2xl lg:block">
                        <span className="text-sm font-bold uppercase tracking-[0.12em] text-white/70">Information lifecycle</span>
                        <div className="mt-5 space-y-4 text-base"><p>Acquire</p><p>Organise</p><p>Preserve</p><p>Connect</p></div>
                    </div>
                    <div className="absolute -bottom-8 right-8 border border-[#071A2F]/15 bg-white px-6 py-5 shadow-2xl">
                        <strong className="font-['Libre_Caslon_Display',Georgia,serif] text-2xl font-normal text-[#071A2F]">Knowledge. Access. Impact.</strong>
                    </div>
                </div>
            </div>
        </section>
    );
}

export function SchoolOfYogaNaturopathyHero({
    image = SchoolofYogaandNaturopathyImage,
    exploreHref = "#academic-programs",
    applyHref = "/apply-online",
}) {
    return (
        <section className="relative overflow-hidden bg-[#F7F2E8] text-[#132337]">
            <div className="absolute inset-y-0 right-0 w-full lg:w-[52%]"><img src={image} alt="Yoga, meditation and natural wellness environment" className="h-full w-full object-cover" /><div className="absolute inset-0 bg-[linear-gradient(90deg,#F7F2E8_0%,rgba(247,242,232,0.68)_28%,rgba(247,242,232,0.04)_72%)] lg:bg-[linear-gradient(90deg,#F7F2E8_0%,rgba(247,242,232,0.25)_18%,rgba(247,242,232,0.02)_58%)]" /></div>
            <div className="pointer-events-none absolute left-[58%] top-[12%] hidden h-[520px] w-[520px] rounded-full border border-white/40 lg:block" />
            <div className="pointer-events-none absolute left-[63%] top-[18%] hidden h-[390px] w-[390px] rounded-full border border-[#D5AD57]/40 lg:block" />
            <div className="mx-auto flex min-h-[840px] w-[min(1380px,calc(100%-48px))] items-center py-24 max-sm:w-[calc(100%-28px)]">
                <div className="relative z-10 max-w-[760px]">
                    <Breadcrumb current="Yoga & Naturopathy" />
                    <div className="mt-10"><Eyebrow>School of Yoga & Naturopathy</Eyebrow></div>
                    <h1 className="mt-6 font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(52px,6.5vw,92px)] font-normal leading-[1] tracking-[-0.05em] text-[#071A2F]">Science of wellbeing. <em className="block font-normal text-[#8B1E3F]">Wisdom for life.</em></h1>
                    <p className="mt-7 max-w-[650px] text-base leading-8 text-[#586575]">Study yoga science, naturopathy, mindfulness and holistic health through disciplined practice, evidence-informed learning and a deep respect for nature.</p>
                    <div className="mt-9 flex flex-wrap gap-4"><HeroButton href={exploreHref}>Explore Programmes</HeroButton><HeroButton href={applyHref} variant="secondary">Apply Now</HeroButton></div>
                    <div className="mt-12 grid max-w-[700px] gap-4 sm:grid-cols-4">{[["Body", "Movement"], ["Mind", "Awareness"], ["Nature", "Healing"], ["Life", "Balance"]].map(([a, b]) => <div key={a} className="border-t border-[#071A2F]/15 py-4"><strong className="font-['Libre_Caslon_Display',Georgia,serif] text-2xl font-normal text-[#071A2F]">{a}</strong><span className="mt-1 block text-sm text-[#65717D]">{b}</span></div>)}</div>
                </div>
            </div>
        </section>
    );
}

export function SchoolOfLifeScienceHero({
    image = SchoolofLifeScienceImage,
    exploreHref = "#academic-programs",
    applyHref = "/apply-online",
}) {
    return (
        <section className="relative isolate min-h-[850px] overflow-hidden bg-[#071A2F] text-white">
            <div className="absolute inset-0 -z-30"><img src={image} alt="Biotechnology and microbiology research" className="h-full w-full object-cover" /></div>
            <div className="absolute inset-0 -z-20 bg-[linear-gradient(90deg,rgba(7,26,47,0.98)_0%,rgba(7,26,47,0.93)_46%,rgba(7,26,47,0.6)_100%)]" />
            <div className="absolute inset-0 -z-10 bg-[radial-gradient(circle_at_78%_45%,rgba(213,173,87,0.14),transparent_28%)]" />
            <div className="mx-auto grid min-h-[850px] w-[min(1380px,calc(100%-48px))] items-center gap-14 py-28 max-sm:w-[calc(100%-28px)] lg:grid-cols-[0.88fr_1.12fr]">
                <div className="relative z-10">
                    <Breadcrumb current="Life Science" dark />
                    <div className="mt-10"><Eyebrow dark>School of Life Science</Eyebrow></div>
                    <h1 className="mt-6 max-w-[820px] font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(54px,7vw,98px)] font-normal leading-[0.98] tracking-[-0.055em]">Decode life. <em className="block font-normal text-[#D5AD57]">Design better futures.</em></h1>
                    <p className="mt-7 max-w-[680px] text-base leading-8 text-white/65">Explore biotechnology, microbiology, genetics and cellular systems through advanced laboratory research and biological innovation.</p>
                    <div className="mt-9 flex flex-wrap gap-4"><HeroButton href={exploreHref}>Explore Programmes</HeroButton><HeroButton href={applyHref} variant="secondary" dark>Apply Now</HeroButton></div>
                </div>
                <div className="relative hidden min-h-[630px] lg:block">
                    <div className="absolute left-[18%] top-[7%] h-[500px] w-[500px] rounded-full border border-white/20 bg-[#071A2F]/40 backdrop-blur-sm">
                        <div className="absolute inset-[9%] rounded-full border border-[#D5AD57]/30" />
                        <div className="absolute inset-[20%] rounded-full border border-white/15" />
                        <svg viewBox="0 0 500 500" className="h-full w-full" fill="none" aria-hidden="true">
                            <path d="M134 92C218 132 190 221 270 258C355 297 307 397 379 430" stroke="#D5AD57" strokeWidth="3" />
                            <path d="M366 70C286 119 318 207 235 250C158 290 193 383 119 426" stroke="#8B1E3F" strokeWidth="3" />
                            {Array.from({ length: 10 }).map((_, i) => <circle key={i} cx={150 + i * 24} cy={110 + i * 29} r="8" fill="#071A2F" stroke={i % 2 ? "#D5AD57" : "#8B1E3F"} strokeWidth="2" />)}
                        </svg>
                    </div>
                    {[["Genetics", "top-[10%] left-0"], ["Microbiology", "top-[24%] right-0"], ["Biotechnology", "bottom-[20%] left-[2%]"], ["Cell Biology", "bottom-[8%] right-[3%]"]].map(([title, pos], i) => <div key={title} className={`absolute ${pos} w-48 border border-white/20 bg-[#0C2744]/85 p-5 backdrop-blur-xl`}><span className="text-sm font-bold text-[#D5AD57]">0{i + 1}</span><strong className="mt-2 block font-['Libre_Caslon_Display',Georgia,serif] text-xl font-normal">{title}</strong></div>)}
                </div>
            </div>
        </section>
    );
}

export function SchoolOfVocationalManagementHero({
    image = SchoolOfVocationalManagementImage,
    exploreHref = "#academic-programs",
    applyHref = "/apply-online",
}) {
    return (
        <section className="relative overflow-hidden bg-white text-[#132337]">
            <div className="absolute inset-y-0 right-0 hidden w-[42%] bg-[#8B1E3F] lg:block" />
            <div className="relative mx-auto grid min-h-[790px] w-[min(1380px,calc(100%-48px))] items-center gap-12 py-24 max-sm:w-[calc(100%-28px)] lg:grid-cols-[1fr_0.88fr]">
                <div>
                    <div className="flex items-center gap-3 text-sm font-extrabold uppercase tracking-[0.16em] text-[#8B1E3F]"><span className="h-px w-10 bg-current" />School of Vocational Management</div>
                    <h1 className="mt-6 max-w-[900px] font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(54px,6.5vw,98px)] font-normal leading-[1] tracking-[-0.05em] text-[#071A2F]">
                        Skills that work.
                        <em className="block font-normal text-[#8B1E3F]">Careers that grow.</em>
                    </h1>
                    <p className="mt-7 max-w-[700px] text-base leading-8 text-[#586575]">Build job-ready capabilities through practical education, industry-aligned training and specialised pathways across high-growth sectors.</p>
                    <div className="mt-9 flex flex-wrap gap-4">
                        <a href="#academic-programs" className="inline-flex min-h-[54px] items-center gap-5 bg-[#071A2F] px-7 text-sm font-extrabold uppercase tracking-[0.08em] text-white transition hover:bg-[#8B1E3F]">Explore Programmes <span>↗</span></a>
                        <a href="/apply-online" className="inline-flex min-h-[54px] items-center gap-5 border-2 border-[#071A2F] px-7 text-sm font-extrabold uppercase tracking-[0.08em] text-[#071A2F] transition hover:bg-[#071A2F] hover:text-white">Apply Now <span>→</span></a>
                    </div>
                    <div className="mt-12 grid gap-px bg-[#071A2F]/10 sm:grid-cols-3">
                        {sectors.map((item, index) => (
                            <div key={item} className="min-h-[92px] bg-[#F7F2E8] p-5 transition hover:bg-[#EEE5D3]">
                                <span className="text-sm font-bold text-[#8B1E3F]">0{index + 1}</span>
                                <strong className="mt-2 block text-base font-semibold text-[#071A2F]">{item}</strong>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="relative min-h-[600px]">
                    <div className="absolute inset-0 overflow-hidden lg:left-8">
                        <img src={image} alt="Students engaged in vocational and practical learning" className="h-full w-full object-cover" />
                        <div className="absolute inset-0 bg-[linear-gradient(180deg,transparent_35%,rgba(7,26,47,.72)_100%)]" />
                    </div>
                    <div className="absolute left-0 top-10 hidden w-[210px] bg-[#071A2F] p-6 text-white shadow-2xl lg:block">
                        <span className="text-sm font-bold uppercase tracking-[0.12em] text-[#D5AD57]">Learning model</span>
                        <strong className="mt-4 block font-['Libre_Caslon_Display',Georgia,serif] text-3xl font-normal">Learn. Practise. Perform.</strong>
                    </div>
                    <div className="absolute bottom-8 right-8 border border-white/20 bg-white/90 p-6 text-[#071A2F] shadow-2xl backdrop-blur-xl">
                        <span className="text-sm font-bold uppercase tracking-[0.12em] text-[#8B1E3F]">Career focused</span>
                        <p className="mt-3 max-w-[260px] text-base leading-7">Industry exposure, applied projects and role-specific capability.</p>
                    </div>
                </div>
            </div>
        </section>
    );
}

export function SchoolOfHealthAlliedScienceHero({
    image = SchoolofHealthandAlliedScienceImage,
    exploreHref = "#academic-programs",
    applyHref = "/apply-online",
}) {
    return (
        <section className="relative overflow-hidden bg-white text-[#132337]">
            <div className="absolute inset-y-0 right-0 hidden w-[49%] bg-[#071A2F] lg:block" />
            <div className="mx-auto grid min-h-[850px] w-[min(1380px,calc(100%-48px))] items-center gap-14 py-24 max-sm:w-[calc(100%-28px)] lg:grid-cols-[0.88fr_1.12fr]">
                <div className="relative z-10">
                    <Breadcrumb current="Health & Allied Science" />
                    <div className="mt-10"><Eyebrow>School of Health & Allied Science</Eyebrow></div>
                    <h1 className="mt-6 max-w-[790px] font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(52px,6.5vw,92px)] font-normal leading-[0.98] tracking-[-0.055em] text-[#071A2F]">Clinical knowledge. <em className="block font-normal text-[#8B1E3F]">Compassionate care.</em></h1>
                    <p className="mt-7 max-w-[660px] text-base leading-8 text-[#586575]">Prepare for healthcare, diagnostics, physiotherapy, nutrition, public health and allied clinical practice through evidence-led education and patient-centred learning.</p>
                    <div className="mt-9 flex flex-wrap gap-4"><HeroButton href={exploreHref}>Explore Programmes</HeroButton><HeroButton href={applyHref} variant="secondary">Apply Now</HeroButton></div>
                    <div className="mt-12 grid max-w-[720px] gap-4 sm:grid-cols-3">{[["Clinical", "Practice"], ["Diagnostic", "Precision"], ["Patient", "Care"]].map(([a, b]) => <Metric key={a} value={a} label={b} />)}</div>
                </div>

                <div className="relative min-h-[650px]">
                    <div className="absolute inset-x-[5%] top-[6%] h-[78%] overflow-hidden rounded-[12px_70px_12px_70px] border-[10px] border-white shadow-[0_35px_100px_rgba(7,26,47,0.25)]">
                        <img src={image} alt="Healthcare professionals and clinical learning" className="h-full w-full object-cover" />
                    </div>
                    <div className="absolute left-0 top-[13%] w-56 bg-white p-5 shadow-[0_25px_70px_rgba(0,0,0,0.22)]"><span className="text-sm font-bold uppercase tracking-[0.12em] text-[#8B1E3F]">Clinical Pathways</span><div className="mt-5 space-y-4">{["Physiotherapy", "Diagnostics", "Nutrition", "Public Health"].map((item, i) => <div key={item} className="flex items-center gap-3 border-b border-[#071A2F]/10 pb-3"><span className="text-sm font-bold text-[#A77B2D]">0{i + 1}</span><span className="text-sm font-semibold text-[#071A2F]">{item}</span></div>)}</div></div>
                    <div className="absolute bottom-[6%] right-0 w-[56%] border border-white/20 bg-[#071A2F]/90 p-6 text-white backdrop-blur-xl"><div className="flex items-center justify-between"><div><span className="text-sm font-bold uppercase tracking-[0.12em] text-[#D5AD57]">Patient Care Journey</span><strong className="mt-2 block font-['Libre_Caslon_Display',Georgia,serif] text-2xl font-normal">Assess. Support. Restore.</strong></div><div className="grid h-16 w-16 place-items-center rounded-full border border-[#D5AD57]/40 text-3xl text-[#D5AD57]">+</div></div></div>
                </div>
            </div>
        </section>
    );
}

export const schoolHeroComponents = {
    "school-of-management": SchoolOfManagementHero,
    "school-of-commerce": SchoolOfCommerceHero,
    "school-of-engineering-and-technology": SchoolOfEngineeringTechnologyHero,
    "school-of-information-and-technology": SchoolOfInformationTechnologyHero,
    "school-of-science": SchoolOfScienceHero,
    "school-of-arts-and-humanities": SchoolOfArtsHumanitiesHero,
    "school-of-law": SchoolOfLawHero,
    "school-of-pharmacy": SchoolOfPharmacyHero,
    "school-of-design": SchoolOfDesignHero,
    "school-of-education": SchoolOfEducationHero,
    "school-of-journalism-and-mass-communication":
        SchoolOfJournalismMassCommunicationHero,
    "school-of-hotel-management": SchoolOfHotelManagementHero,
    "school-of-media-and-entertainment": SchoolOfMediaEntertainmentHero,
    "school-of-library-and-information-science":
        SchoolOfLibraryInformationScienceHero,
    "school-of-yoga-and-naturopathy": SchoolOfYogaNaturopathyHero,
    "school-of-life-science": SchoolOfLifeScienceHero,
    "school-of-vocational-management": SchoolOfVocationalManagementHero,
    "school-of-health-and-allied-science": SchoolOfHealthAlliedScienceHero,
};

export { palette };